// import React, { useState, useEffect } from 'react';
// import { ref, push, set, onValue, remove, update } from 'firebase/database';
// import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
// import { database, storage } from '../firebase';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import 'bootstrap/dist/css/bootstrap.min.css';



// const localizer = momentLocalizer(moment);

// const AcademicAdminDashboard = () => {
//   // State for Classes Management
//   const [classes, setClasses] = useState([]);
//   const [newClassName, setNewClassName] = useState('');
//   const [newClassTeacher, setNewClassTeacher] = useState('');
//   const [newClassRoom, setNewClassRoom] = useState('');

//     const [isEditingEvent, setIsEditingEvent] = useState(false);

//   // State for Yearly Plans
//   const [selectedClass, setSelectedClass] = useState('');
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [planFile, setPlanFile] = useState(null);
//   const [uploadingPlan, setUploadingPlan] = useState(false);
//   const [existingPlans, setExistingPlans] = useState([]);

//   const [calendarView, setCalendarView] = useState('month');
// const [currentDate, setCurrentDate] = useState(new Date());

//   // State for Syllabus Management
//   const [syllabusFile, setSyllabusFile] = useState(null);
//   const [uploadingSyllabus, setUploadingSyllabus] = useState(false);
//   const [existingSyllabi, setExistingSyllabi] = useState([]);


//   const [examTimetableFile, setExamTimetableFile] = useState(null);
// const [uploadingExamTimetable, setUploadingExamTimetable] = useState(false);
// const [existingExamTimetables, setExistingExamTimetables] = useState([]);


//   // State for Exams Management
//   const [exams, setExams] = useState([]);
//   const [newExam, setNewExam] = useState({
//     name: '',
//     date: new Date().toISOString().split('T')[0],
//     description: '',
//     syllabusCovered: ''
//   });

//   // State for School Calendar
//   const [events, setEvents] = useState([]);
//   const [newEvent, setNewEvent] = useState({
//     title: '',
//     start: new Date(),
//     end: new Date(),
//     description: '',
//     type: 'holiday'
//   });

//   // Fetch all classes
//   useEffect(() => {
//     const classesRef = ref(database, 'school/classes');
//     onValue(classesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const classesArray = Object.entries(data).map(([id, classData]) => ({
//           id,
//           ...classData
//         }));
//         setClasses(classesArray);
//       }
//     });
//   }, []);

//   // Fetch existing yearly plans when class is selected
//   useEffect(() => {
//     if (selectedClass) {
//       const plansRef = ref(database, `school/academic/${selectedClass}/yearlyPlans`);
//       onValue(plansRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const plansArray = Object.entries(data).map(([id, plan]) => ({
//             id,
//             ...plan
//           }));
//           setExistingPlans(plansArray);
//         } else {
//           setExistingPlans([]);
//         }
//       });
//     }
//   }, [selectedClass]);

//   // Fetch existing syllabi when class is selected
//   useEffect(() => {
//     if (selectedClass) {
//       const syllabiRef = ref(database, `school/academic/${selectedClass}/syllabus`);
//       onValue(syllabiRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const syllabiArray = Object.entries(data).map(([id, syllabus]) => ({
//             id,
//             ...syllabus
//           }));
//           setExistingSyllabi(syllabiArray);
//         } else {
//           setExistingSyllabi([]);
//         }
//       });
//     }
//   }, [selectedClass]);

//   // Fetch exams when class is selected
// //   useEffect(() => {
// //     if (selectedClass) {
// //       const examsRef = ref(database, `school/academic/${selectedClass}/exams`);
// //       onValue(examsRef, (snapshot) => {
// //         const data = snapshot.val();
// //         if (data) {
// //           const examsArray = Object.entries(data).map(([id, exam]) => ({
// //             id,
// //             ...exam,
// //             date: exam.date || new Date().toISOString().split('T')[0]
// //           }));
// //           setExams(examsArray);
// //         } else {
// //           setExams([]);
// //         }
// //       });
// //     }
// //   }, [selectedClass]);

// useEffect(() => {
//   if (selectedClass) {
//     const timetablesRef = ref(database, `school/academic/${selectedClass}/examTimetables`);
//     onValue(timetablesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const timetablesArray = Object.entries(data).map(([id, timetable]) => ({
//           id,
//           ...timetable
//         }));
//         setExistingExamTimetables(timetablesArray);
//       } else {
//         setExistingExamTimetables([]);
//       }
//     });
//   }
// }, [selectedClass]);

//   // Fetch calendar events
// //   useEffect(() => {
// //     const eventsRef = ref(database, 'school/academic/calendar');
// //     onValue(eventsRef, (snapshot) => {
// //       const data = snapshot.val();
// //       if (data) {
// //         const eventsArray = Object.entries(data).map(([id, event]) => ({
// //           id,
// //           ...event,
// //           start: new Date(event.start),
// //           end: new Date(event.end)
// //         }));
// //         setEvents(eventsArray);
// //       }
// //     });
// //   }, []);

// useEffect(() => {
//   const eventsRef = ref(database, 'school/academic/calendar');
//   onValue(eventsRef, (snapshot) => {
//     const data = snapshot.val();
//     if (data) {
//       const eventsArray = Object.entries(data).map(([id, event]) => ({
//         id,
//         ...event,
//         start: new Date(event.start), // Ensure proper Date object
//         end: new Date(event.end)      // Ensure proper Date object
//       }));
//       setEvents(eventsArray);
//     } else {
//       setEvents([]);
//     }
//   });
// }, []);




// const updateCalendarEvent = async () => {
//     if (!newEvent.title) {
//       alert('Please enter event title');
//       return;
//     }

//     try {
//       await update(ref(database, `school/academic/calendar/${newEvent.id}`), {
//         ...newEvent,
//         start: newEvent.start.toISOString(),
//         end: newEvent.end.toISOString()
//       });

//       setNewEvent({
//         title: '',
//         start: new Date(),
//         end: new Date(),
//         description: '',
//         type: 'holiday'
//       });
//       setIsEditingEvent(false);
//       alert('Event updated successfully!');
//     } catch (error) {
//       console.error('Error updating event:', error);
//       alert('Failed to update event');
//     }
//   };

//   // Add new class
//   const addClass = async () => {
//     if (!newClassName) {
//       alert('Please enter class name');
//       return;
//     }

//     try {
//       const classRef = push(ref(database, 'school/classes'));
//       await set(classRef, {
//         name: newClassName,
//         teacher: newClassTeacher,
//         room: newClassRoom,
//         createdAt: new Date().toISOString()
//       });

//       setNewClassName('');
//       setNewClassTeacher('');
//       setNewClassRoom('');
//     } catch (error) {
//       console.error('Error adding class:', error);
//       alert('Failed to add class');
//     }
//   };

//   // Delete class
//   const deleteClass = async (classId) => {
//     if (window.confirm('Are you sure you want to delete this class and all its academic data?')) {
//       try {
//         // Delete class record
//         await remove(ref(database, `school/classes/${classId}`));
        
//         // Delete academic data
//         await remove(ref(database, `school/academic/${classId}`));
        
//         alert('Class deleted successfully');
//       } catch (error) {
//         console.error('Error deleting class:', error);
//         alert('Failed to delete class');
//       }
//     }
//   };

//   // Upload Yearly Plan
//   const uploadYearlyPlan = async () => {
//     if (!selectedClass || !planFile) {
//       alert('Please select a class and file');
//       return;
//     }

//     try {
//       setUploadingPlan(true);
      
//       // Upload file to storage
//       const filePath = `academic/${selectedClass}/plans/${selectedYear}-${Date.now()}`;
//       const fileRef = storageRef(storage, filePath);
//       await uploadBytes(fileRef, planFile);
//       const downloadURL = await getDownloadURL(fileRef);

//       // Save to database
//       const planRef = push(ref(database, `school/academic/${selectedClass}/yearlyPlans`));
//       await set(planRef, {
//         year: selectedYear,
//         fileUrl: downloadURL,
//         fileName: planFile.name,
//         storagePath: filePath,
//         uploadedAt: new Date().toISOString()
//       });

//       alert('Yearly plan uploaded successfully!');
//       setPlanFile(null);
//     } catch (error) {
//       console.error('Error uploading plan:', error);
//       alert('Failed to upload plan');
//     } finally {
//       setUploadingPlan(false);
//     }
//   };

//   // Delete Yearly Plan
//   const deletePlan = async (plan) => {
//     if (window.confirm('Are you sure you want to delete this plan?')) {
//       try {
//         // Delete from storage
//         if (plan.storagePath) {
//           const fileRef = storageRef(storage, plan.storagePath);
//           await deleteObject(fileRef);
//         }

//         // Delete from database
//         await remove(ref(database, `school/academic/${selectedClass}/yearlyPlans/${plan.id}`));
        
//         alert('Plan deleted successfully');
//       } catch (error) {
//         console.error('Error deleting plan:', error);
//         alert('Failed to delete plan');
//       }
//     }
//   };

//   // Upload Syllabus
//   const uploadSyllabus = async () => {
//     if (!selectedClass || !syllabusFile) {
//       alert('Please select a class and file');
//       return;
//     }

//     try {
//       setUploadingSyllabus(true);
      
//       // Upload file to storage
//       const filePath = `academic/${selectedClass}/syllabus/${Date.now()}`;
//       const fileRef = storageRef(storage, filePath);
//       await uploadBytes(fileRef, syllabusFile);
//       const downloadURL = await getDownloadURL(fileRef);

//       // Save to database
//       const syllabusRef = push(ref(database, `school/academic/${selectedClass}/syllabus`));
//       await set(syllabusRef, {
//         fileUrl: downloadURL,
//         fileName: syllabusFile.name,
//         storagePath: filePath,
//         uploadedAt: new Date().toISOString()
//       });

//       alert('Syllabus uploaded successfully!');
//       setSyllabusFile(null);
//     } catch (error) {
//       console.error('Error uploading syllabus:', error);
//       alert('Failed to upload syllabus');
//     } finally {
//       setUploadingSyllabus(false);
//     }
//   };

//   // Delete Syllabus
//   const deleteSyllabus = async (syllabus) => {
//     if (window.confirm('Are you sure you want to delete this syllabus?')) {
//       try {
//         // Delete from storage
//         if (syllabus.storagePath) {
//           const fileRef = storageRef(storage, syllabus.storagePath);
//           await deleteObject(fileRef);
//         }

//         // Delete from database
//         await remove(ref(database, `school/academic/${selectedClass}/syllabus/${syllabus.id}`));
        
//         alert('Syllabus deleted successfully');
//       } catch (error) {
//         console.error('Error deleting syllabus:', error);
//         alert('Failed to delete syllabus');
//       }
//     }
//   };

// const uploadExamTimetable = async () => {
//   if (!selectedClass || !examTimetableFile) {
//     alert('Please select a class and file');
//     return;
//   }

//   try {
//     setUploadingExamTimetable(true);
    
//     // Upload file to storage
//     const filePath = `academic/${selectedClass}/examTimetables/${Date.now()}`;
//     const fileRef = storageRef(storage, filePath);
//     await uploadBytes(fileRef, examTimetableFile);
//     const downloadURL = await getDownloadURL(fileRef);

//     // Save to database
//     const timetableRef = push(ref(database, `school/academic/${selectedClass}/examTimetables`));
//     await set(timetableRef, {
//       fileUrl: downloadURL,
//       fileName: examTimetableFile.name,
//       storagePath: filePath,
//       uploadedAt: new Date().toISOString(),
//       examName: newExam.name || 'General Timetable'
//     });

//     alert('Exam timetable uploaded successfully!');
//     setExamTimetableFile(null);
//   } catch (error) {
//     console.error('Error uploading timetable:', error);
//     alert('Failed to upload timetable');
//   } finally {
//     setUploadingExamTimetable(false);
//   }
// };

// // Add this function for deleting exam timetable
// const deleteExamTimetable = async (timetable) => {
//   if (window.confirm('Are you sure you want to delete this exam timetable?')) {
//     try {
//       // Delete from storage
//       if (timetable.storagePath) {
//         const fileRef = storageRef(storage, timetable.storagePath);
//         await deleteObject(fileRef);
//       }

//       // Delete from database
//       await remove(ref(database, `school/academic/${selectedClass}/examTimetables/${timetable.id}`));
      
//       alert('Exam timetable deleted successfully');
//     } catch (error) {
//       console.error('Error deleting timetable:', error);
//       alert('Failed to delete timetable');
//     }
//   }
// };

//   // Add Calendar Event
//   const addCalendarEvent = async () => {
//     if (!newEvent.title) {
//       alert('Please enter event title');
//       return;
//     }

//     try {
//       const eventRef = push(ref(database, 'school/academic/calendar'));
//       await set(eventRef, {
//         ...newEvent,
//         start: newEvent.start.toISOString(),
//         end: newEvent.end.toISOString()
//       });

//       setNewEvent({
//         title: '',
//         start: new Date(),
//         end: new Date(),
//         description: '',
//         type: 'holiday'
//       });
//     } catch (error) {
//       console.error('Error adding event:', error);
//       alert('Failed to add event');
//     }
//   };

//   // Delete Calendar Event
//   const deleteEvent = async (eventId) => {
//     if (window.confirm('Are you sure you want to delete this event?')) {
//       try {
//         await remove(ref(database, `school/academic/calendar/${eventId}`));
//       } catch (error) {
//         console.error('Error deleting event:', error);
//         alert('Failed to delete event');
//       }
//     }
//   };

//   // Event style based on type
//   const eventStyleGetter = (event) => {
//     let backgroundColor = '#3174ad';
//     if (event.type === 'holiday') backgroundColor = '#d32f2f';
//     if (event.type === 'exam') backgroundColor = '#ff8f00';
//     if (event.type === 'event') backgroundColor = '#388e3c';




    
//     return {
//       style: {
//         backgroundColor,
//         borderRadius: '4px',
//         opacity: 0.8,
//         color: 'white',
//         border: '0px',
//         display: 'block'
//       }

      
//     };
//   };


//    const containerStyle = {
//     minHeight: '100vh',
//     backgroundColor: '#f8fafc',
//     fontFamily: "'Inter', sans-serif"
//   };

//   // Header style
//   const headerStyle = {
//     background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
//     color: 'white',
//     padding: '1.5rem 2rem',
//     boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
//   };

//   // Card style
//   const cardStyle = {
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden',
//     marginBottom: '1.5rem'
//   };

//   // Card header style
//   const cardHeaderStyle = {
//     backgroundColor: '#f1f5f9',
//     borderBottom: '1px solid #e2e8f0',
//     padding: '1rem 1.5rem',
//     display: 'flex',
//     alignItems: 'center'
//   };

//   // Input style
//   const inputStyle = {
//     width: '100%',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: '1px solid #e2e8f0',
//     fontSize: '0.875rem',
//     outline: 'none',
//     transition: 'all 0.2s',
//     boxSizing: 'border-box'
//   };

//   // Button style
//   const buttonStyle = (disabled = false) => ({
//     backgroundColor: disabled ? '#cbd5e1' : '#4f46e5',
//     color: 'white',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: 'none',
//     cursor: disabled ? 'not-allowed' : 'pointer',
//     fontSize: '0.875rem',
//     fontWeight: '500',
//     transition: 'all 0.2s',
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: disabled ? 'none' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//   });

//   // Delete button style
//   const deleteButtonStyle = {
//     color: '#ef4444',
//     backgroundColor: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     padding: '0.25rem',
//     borderRadius: '50%',
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   };

//   // File input style
//   const fileInputStyle = {
//     display: 'none'
//   };

//     const fileInputLabelStyle = (hasFile) => ({
//     display: 'block',
//     width: '100%',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: `1px solid ${hasFile ? '#bfdbfe' : '#e2e8f0'}`,
//     backgroundColor: hasFile ? '#eff6ff' : 'white',
//     cursor: 'pointer',
//     fontSize: '0.875rem',
//     transition: 'all 0.2s'
//   });


//  return (
//     <div style={containerStyle}>
//       {/* Header */}
//       <header style={headerStyle}>
//         <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>Academic Administration</h1>
//         <p style={{ margin: '0.25rem 0 0', opacity: 0.9, fontSize: '0.875rem' }}>
//           Manage classes, curriculum, and school calendar
//         </p>
//       </header>

//       <main style={{ maxWidth: '1200px', margin: '-2rem auto 0', padding: '0 1.5rem 2rem' }}>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
//           {/* Classes Management Card */}
//           <div style={cardStyle}>
//             <div style={cardHeaderStyle}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
//               </svg>
//               <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Class Management</h2>
//             </div>
//             <div style={{ padding: '1.5rem' }}>
//               <div style={{ marginBottom: '1.5rem' }}>
//                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Class Name</label>
//                 <input
//                   type="text"
//                   style={inputStyle}
//                   value={newClassName}
//                   onChange={(e) => setNewClassName(e.target.value)}
//                   placeholder="e.g., Class 1A"
//                 />
//               </div>
              
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Teacher</label>
//                   <input
//                     type="text"
//                     style={inputStyle}
//                     value={newClassTeacher}
//                     onChange={(e) => setNewClassTeacher(e.target.value)}
//                     placeholder="Teacher's name"
//                   />
//                 </div>
                
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Room</label>
//                   <input
//                     type="text"
//                     style={inputStyle}
//                     value={newClassRoom}
//                     onChange={(e) => setNewClassRoom(e.target.value)}
//                     placeholder="Room number"
//                   />
//                 </div>
//               </div>
              
//               <button
//                 style={buttonStyle(!newClassName)}
//                 onClick={addClass}
//                 disabled={!newClassName}
//               >
//                 Create Class
//               </button>
              
//               <div style={{ marginTop: '1.5rem' }}>
//                 <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
//                   <svg style={{ width: '1rem', height: '1rem', marginRight: '0.5rem', color: '#64748b' }} fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
//                   </svg>
//                   Existing Classes
//                 </h3>
//                 <div style={{ display: 'grid', gap: '0.75rem' }}>
//                   {classes.length > 0 ? (
//                     classes.map(cls => (
//                       <div key={cls.id} style={{ 
//                         padding: '0.75rem', 
//                         borderRadius: '8px', 
//                         border: '1px solid #e2e8f0', 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         transition: 'all 0.2s',
//                         ':hover': {
//                           borderColor: '#c7d2fe',
//                           backgroundColor: '#f8fafc'
//                         }
//                       }}>
//                         <div>
//                           <span style={{ fontWeight: '500', color: '#1e293b' }}>{cls.name}</span>
//                           <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
//                             {cls.teacher && (
//                               <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '0.75rem' }}>
//                                 <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
//                                   <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                                 </svg>
//                                 {cls.teacher}
//                               </span>
//                             )}
//                             {cls.room && (
//                               <span style={{ display: 'inline-flex', alignItems: 'center' }}>
//                                 <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
//                                   <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
//                                 </svg>
//                                 Room {cls.room}
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                         <button
//                           onClick={() => deleteClass(cls.id)}
//                           style={deleteButtonStyle}
//                           title="Delete class"
//                         >
//                           <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                           </svg>
//                         </button>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
//                       <svg style={{ width: '3rem', height: '3rem', margin: '0 auto', color: '#cbd5e1' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                       </svg>
//                       <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.5rem' }}>No classes added yet</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Class Selection Card */}
//           <div style={cardStyle}>
//             <div style={cardHeaderStyle}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//               </svg>
//               <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Academic Content</h2>
//             </div>
//             <div style={{ padding: '1.5rem' }}>
//               <div style={{ marginBottom: '1.5rem' }}>
//                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Select Class</label>
//                 <select
//                   style={inputStyle}
//                   value={selectedClass}
//                   onChange={(e) => setSelectedClass(e.target.value)}
//                 >
//                   <option value="">Choose a class...</option>
//                   {classes.map(cls => (
//                     <option key={cls.id} value={cls.id}>{cls.name}</option>
//                   ))}
//                 </select>
//               </div>
              
//               {selectedClass && (
//                 <div style={{ display: 'grid', gap: '1.5rem' }}>
//                   {/* Yearly Plan Section */}
//                   <div style={{ 
//                     ...cardStyle, 
//                     backgroundColor: '#f0f9ff',
//                     border: '1px solid #bfdbfe'
//                   }}>
//                     <div style={{ 
//                       ...cardHeaderStyle, 
//                       backgroundColor: '#e0f2fe',
//                       borderBottom: '1px solid #bfdbfe'
//                     }}>
//                       <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#0369a1' }} fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z" clipRule="evenodd" />
//                       </svg>
//                       <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#0369a1' }}>Yearly Plan</h3>
//                     </div>
//                     <div style={{ padding: '1rem' }}>
//                       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
//                         <div>
//                           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Academic Year</label>
//                           <input
//                             type="number"
//                             style={inputStyle}
//                             value={selectedYear}
//                             onChange={(e) => setSelectedYear(e.target.value)}
//                             min="2000"
//                             max="2100"
//                           />
//                         </div>
                        
//                         <div>
//                           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Plan File</label>
//                           <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <label style={fileInputLabelStyle(planFile)}>
//                               {planFile ? planFile.name : 'Choose file...'}
//                               <input
//                                 type="file"
//                                 style={fileInputStyle}
//                                 onChange={(e) => setPlanFile(e.target.files[0])}
//                                 accept=".pdf,.doc,.docx"
//                               />
//                             </label>
//                             {planFile && (
//                               <button 
//                                 onClick={() => setPlanFile(null)}
//                                 style={{ 
//                                   marginLeft: '0.5rem', 
//                                   padding: '0.25rem', 
//                                   color: '#ef4444', 
//                                   backgroundColor: 'transparent', 
//                                   border: 'none', 
//                                   cursor: 'pointer',
//                                   borderRadius: '50%'
//                                 }}
//                                 title="Remove file"
//                               >
//                                 <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                                 </svg>
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       </div>
                      
//                       <button
//                         style={buttonStyle(uploadingPlan || !planFile)}
//                         onClick={uploadYearlyPlan}
//                         disabled={uploadingPlan || !planFile}
//                       >
//                         {uploadingPlan ? (
//                           <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                             <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                               <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                               <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                             </svg>
//                             Uploading...
//                           </span>
//                         ) : 'Upload Plan'}
//                       </button>
                      
//                       {existingPlans.length > 0 && (
//                         <div style={{ marginTop: '1rem' }}>
//                           <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Existing Plans:</h4>
//                           <div style={{ display: 'grid', gap: '0.5rem' }}>
//                             {existingPlans.map(plan => (
//                               <div key={plan.id} style={{ 
//                                 padding: '0.75rem', 
//                                 borderRadius: '8px', 
//                                 backgroundColor: 'white', 
//                                 border: '1px solid #e2e8f0',
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center'
//                               }}>
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                   <svg style={{ width: '1.25rem', height: '1.25rem', color: '#3b82f6', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                                     <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm4-1a1 1 0 10-2 0v4a1 1 0 102 0V8z" clipRule="evenodd" />
//                                   </svg>
//                                   <div>
//                                     <span style={{ fontWeight: '500', color: '#1e293b' }}>{plan.year}</span>
//                                     <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{plan.fileName}</span>
//                                   </div>
//                                 </div>
//                                 <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                   <a 
//                                     href={plan.fileUrl} 
//                                     target="_blank" 
//                                     rel="noopener noreferrer"
//                                     style={{ 
//                                       padding: '0.25rem', 
//                                       color: '#3b82f6', 
//                                       backgroundColor: '#eff6ff', 
//                                       borderRadius: '50%',
//                                       display: 'inline-flex',
//                                       alignItems: 'center',
//                                       justifyContent: 'center'
//                                     }}
//                                     title="View"
//                                   >
//                                     <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                                     </svg>
//                                   </a>
//                                   <button
//                                     onClick={() => deletePlan(plan)}
//                                     style={{ 
//                                       padding: '0.25rem', 
//                                       color: '#ef4444', 
//                                       backgroundColor: '#fef2f2', 
//                                       borderRadius: '50%',
//                                       display: 'inline-flex',
//                                       alignItems: 'center',
//                                       justifyContent: 'center',
//                                       border: 'none',
//                                       cursor: 'pointer'
//                                     }}
//                                     title="Delete"
//                                   >
//                                     <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                                     </svg>
//                                   </button>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
                  
//                   {/* Syllabus Section */}
//                   <div style={{ 
//                     ...cardStyle, 
//                     backgroundColor: '#ecfdf5',
//                     border: '1px solid #a7f3d0'
//                   }}>
//                     <div style={{ 
//                       ...cardHeaderStyle, 
//                       backgroundColor: '#d1fae5',
//                       borderBottom: '1px solid #a7f3d0'
//                     }}>
//                       <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#047857' }} fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
//                       </svg>
//                       <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#047857' }}>Class Syllabus</h3>
//                     </div>
//                     <div style={{ padding: '1rem' }}>
//                       <div style={{ marginBottom: '1rem' }}>
//                         <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Syllabus File</label>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                           <label style={fileInputLabelStyle(syllabusFile)}>
//                             {syllabusFile ? syllabusFile.name : 'Choose file...'}
//                             <input
//                               type="file"
//                               style={fileInputStyle}
//                               onChange={(e) => setSyllabusFile(e.target.files[0])}
//                               accept=".pdf,.doc,.docx"
//                             />
//                           </label>
//                           {syllabusFile && (
//                             <button 
//                               onClick={() => setSyllabusFile(null)}
//                               style={{ 
//                                 marginLeft: '0.5rem', 
//                                 padding: '0.25rem', 
//                                 color: '#ef4444', 
//                                 backgroundColor: 'transparent', 
//                                 border: 'none', 
//                                 cursor: 'pointer',
//                                 borderRadius: '50%'
//                               }}
//                               title="Remove file"
//                             >
//                               <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                               </svg>
//                             </button>
//                           )}
//                         </div>
//                       </div>
                      
//                       <button
//                         style={buttonStyle(uploadingSyllabus || !syllabusFile)}
//                         onClick={uploadSyllabus}
//                         disabled={uploadingSyllabus || !syllabusFile}
//                       >
//                         {uploadingSyllabus ? (
//                           <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                             <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                               <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                               <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                             </svg>
//                             Uploading...
//                           </span>
//                         ) : 'Upload Syllabus'}
//                       </button>
                      
//                       {existingSyllabi.length > 0 && (
//                         <div style={{ marginTop: '1rem' }}>
//                           <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Current Syllabus:</h4>
//                           <div style={{ display: 'grid', gap: '0.5rem' }}>
//                             {existingSyllabi.map(syllabus => (
//                               <div key={syllabus.id} style={{ 
//                                 padding: '0.75rem', 
//                                 borderRadius: '8px', 
//                                 backgroundColor: 'white', 
//                                 border: '1px solid #e2e8f0',
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center'
//                               }}>
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                   <svg style={{ width: '1.25rem', height: '1.25rem', color: '#10b981', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                                     <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//                                   </svg>
//                                   <span style={{ fontSize: '0.875rem' }}>{syllabus.fileName}</span>
//                                 </div>
//                                 <div style={{ display: 'flex', gap: '0.5rem' }}>
//                                   <a 
//                                     href={syllabus.fileUrl} 
//                                     target="_blank" 
//                                     rel="noopener noreferrer"
//                                     style={{ 
//                                       padding: '0.25rem', 
//                                       color: '#10b981', 
//                                       backgroundColor: '#ecfdf5', 
//                                       borderRadius: '50%',
//                                       display: 'inline-flex',
//                                       alignItems: 'center',
//                                       justifyContent: 'center'
//                                     }}
//                                     title="View"
//                                   >
//                                     <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                                     </svg>
//                                   </a>
//                                   <button
//                                     onClick={() => deleteSyllabus(syllabus)}
//                                     style={{ 
//                                       padding: '0.25rem', 
//                                       color: '#ef4444', 
//                                       backgroundColor: '#fef2f2', 
//                                       borderRadius: '50%',
//                                       display: 'inline-flex',
//                                       alignItems: 'center',
//                                       justifyContent: 'center',
//                                       border: 'none',
//                                       cursor: 'pointer'
//                                     }}
//                                     title="Delete"
//                                   >
//                                     <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                                     </svg>
//                                   </button>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
                  

// <div style={{ marginTop: '1rem' }}>
//   <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Exam Timetable</h4>
//   <div style={{ marginBottom: '1rem' }}>
//     <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Timetable File</label>
//     <div style={{ display: 'flex', alignItems: 'center' }}>
//       <label style={fileInputLabelStyle(examTimetableFile)}>
//         {examTimetableFile ? examTimetableFile.name : 'Choose file...'}
//         <input
//           type="file"
//           style={fileInputStyle}
//           onChange={(e) => setExamTimetableFile(e.target.files[0])}
//           accept=".pdf,.doc,.docx,.jpg,.png"
//         />
//       </label>
//       {examTimetableFile && (
//         <button 
//           onClick={() => setExamTimetableFile(null)}
//           style={{ 
//             marginLeft: '0.5rem', 
//             padding: '0.25rem', 
//             color: '#ef4444', 
//             backgroundColor: 'transparent', 
//             border: 'none', 
//             cursor: 'pointer',
//             borderRadius: '50%'
//           }}
//           title="Remove file"
//         >
//           <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//           </svg>
//         </button>
//       )}
//     </div>
//   </div>
  
//   <button
//     style={buttonStyle(uploadingExamTimetable || !examTimetableFile)}
//     onClick={uploadExamTimetable}
//     disabled={uploadingExamTimetable || !examTimetableFile}
//   >
//     {uploadingExamTimetable ? (
//       <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//         <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//           <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//           <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//         </svg>
//         Uploading...
//       </span>
//     ) : 'Upload Timetable'}
//   </button>
  
//   {existingExamTimetables.length > 0 && (
//     <div style={{ marginTop: '1rem' }}>
//       <h5 style={{ fontSize: '0.75rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Uploaded Timetables:</h5>
//       <div style={{ display: 'grid', gap: '0.5rem' }}>
//         {existingExamTimetables.map(timetable => (
//           <div key={timetable.id} style={{ 
//             padding: '0.75rem', 
//             borderRadius: '8px', 
//             backgroundColor: 'white', 
//             border: '1px solid #e2e8f0',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', color: '#7c3aed', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//               </svg>
//               <div>
//                 <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>{timetable.examName || 'Exam Timetable'}</span>
//                 <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{timetable.fileName}</span>
//               </div>
//             </div>
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               <a 
//                 href={timetable.fileUrl} 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 style={{ 
//                   padding: '0.25rem', 
//                   color: '#7c3aed', 
//                   backgroundColor: '#ede9fe', 
//                   borderRadius: '50%',
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//                 title="View"
//               >
//                 <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                 </svg>
//               </a>
//               <button
//                 onClick={() => deleteExamTimetable(timetable)}
//                 style={{ 
//                   padding: '0.25rem', 
//                   color: '#ef4444', 
//                   backgroundColor: '#fef2f2', 
//                   borderRadius: '50%',
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   border: 'none',
//                   cursor: 'pointer'
//                 }}
//                 title="Delete"
//               >
//                 <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   )}
// </div>

//                 </div>
//               )}
//             </div>
//           </div>

//           {/* School Calendar Card - Full Width */}
//           <div style={{ ...cardStyle, gridColumn: '1 / -1' }}>
//   <div style={cardHeaderStyle}>
//     <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
//       <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//     </svg>
//     <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>School Calendar</h2>
//   </div>
//   <div style={{ padding: '1.5rem' }}>
//     <div style={{ marginBottom: '1.5rem' }} id="event-form-section">
//       <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem' }}>
//         {newEvent.id ? 'Edit Event' : 'Add New Event'}
//       </h3>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Event Title</label>
//           <input
//             type="text"
//             style={inputStyle}
//             value={newEvent.title}
//             onChange={(e) => setNewEvent({...newEvent, title: e.target.value})}
//           />
//         </div>
        
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Event Type</label>
//           <select
//             style={inputStyle}
//             value={newEvent.type}
//             onChange={(e) => setNewEvent({...newEvent, type: e.target.value})}
//           >
//             <option value="holiday">Holiday</option>
//             <option value="exam">Exam</option>
//             <option value="event">School Event</option>
//           </select>
//         </div>
        
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Start Date & Time</label>
//           <input
//             type="datetime-local"
//             style={inputStyle}
//             value={moment(newEvent.start).format('YYYY-MM-DDTHH:mm')}
//             onChange={(e) => setNewEvent({...newEvent, start: new Date(e.target.value)})}
//           />
//         </div>
        
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>End Date & Time</label>
//           <input
//             type="datetime-local"
//             style={inputStyle}
//             value={moment(newEvent.end).format('YYYY-MM-DDTHH:mm')}
//             onChange={(e) => setNewEvent({...newEvent, end: new Date(e.target.value)})}
//           />
//         </div>
        
//         <div style={{ gridColumn: '1 / -1' }}>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Description</label>
//           <textarea
//             style={{ ...inputStyle, minHeight: '5rem' }}
//             value={newEvent.description}
//             onChange={(e) => setNewEvent({...newEvent, description: e.target.value})}
//           />
//         </div>
        
//         <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
//           {newEvent.id && (
//             <button
//               style={{ 
//                 ...buttonStyle(),
//                 padding: '0.5rem 1.5rem',
//                 backgroundColor: '#ef4444',
//                 ':hover': {
//                   backgroundColor: '#dc2626'
//                 }
//               }}
//               onClick={() => {
//                 if (window.confirm('Are you sure you want to delete this event?')) {
//                   deleteEvent(newEvent.id);
//                 }
//               }}
//             >
//               Delete Event
//             </button>
//           )}
//           {newEvent.id && (
//             <button
//               style={{ 
//                 ...buttonStyle(),
//                 padding: '0.5rem 1.5rem',
//                 backgroundColor: '#64748b',
//                 ':hover': {
//                   backgroundColor: '#475569'
//                 }
//               }}
//               onClick={() => {
//                 setNewEvent({
//                   title: '',
//                   start: new Date(),
//                   end: new Date(),
//                   description: '',
//                   type: 'holiday'
//                 });
//               }}
//             >
//               Cancel
//             </button>
//           )}
//           <button
//             style={{ 
//               ...buttonStyle(),
//               padding: '0.5rem 1.5rem',
//               backgroundColor: '#4f46e5',
//               ':hover': {
//                 backgroundColor: '#4338ca'
//               }
//             }}
//             onClick={newEvent.id ? updateCalendarEvent : addCalendarEvent}
//           >
//             {newEvent.id ? 'Update Event' : 'Add to Calendar'}
//           </button>
//         </div>
//       </div>
//     </div>
    
//     <div style={{ height: '600px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
//       <Calendar
//         localizer={localizer}
//         events={events}
//         startAccessor="start"
//         endAccessor="end"
//         style={{ height: '100%' }}
//         eventPropGetter={eventStyleGetter}
//         onSelectEvent={(event) => {
//           setNewEvent({
//             id: event.id,
//             title: event.title,
//             start: new Date(event.start),
//             end: new Date(event.end),
//             description: event.description || '',
//             type: event.type || 'event'
//           });
//           document.getElementById('event-form-section')?.scrollIntoView({ behavior: 'smooth' });
//         }}
//         selectable
//         views={['month', 'week', 'day', 'agenda']}
//         view={calendarView}
//         onView={(view) => setCalendarView(view)}
//         date={currentDate}
//         onNavigate={(date) => {
//           setCurrentDate(date);
//         }}
//         components={{
//           event: ({ event }) => (
//             <div style={{ 
//               padding: '0.25rem',
//               whiteSpace: 'nowrap',
//               overflow: 'hidden',
//               textOverflow: 'ellipsis'
//             }}>
//               <strong>{event.title}</strong>
//               {event.description && (
//                 <p style={{ fontSize: '0.75rem', marginTop: '0.25rem', whiteSpace: 'normal' }}>
//                   {event.description}
//                 </p>
//               )}
//             </div>
//           ),
//           toolbar: (toolbarProps) => (
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               padding: '0.5rem',
//               backgroundColor: '#f8fafc',
//               borderBottom: '1px solid #e2e8f0'
//             }}>
//               <div style={{ display: 'flex', gap: '0.5rem' }}>
//                 <button
//                   style={{ 
//                     ...buttonStyle(),
//                     padding: '0.25rem 0.5rem',
//                     fontSize: '0.75rem'
//                   }}
//                   onClick={() => {
//                     const newDate = new Date(currentDate);
//                     if (calendarView === 'month') {
//                       newDate.setMonth(newDate.getMonth() - 1);
//                     } else if (calendarView === 'week') {
//                       newDate.setDate(newDate.getDate() - 7);
//                     } else {
//                       newDate.setDate(newDate.getDate() - 1);
//                     }
//                     setCurrentDate(newDate);
//                     toolbarProps.onNavigate('PREV');
//                   }}
//                 >
//                   Back
//                 </button>
//                 <button
//                   style={{ 
//                     ...buttonStyle(),
//                     padding: '0.25rem 0.5rem',
//                     fontSize: '0.75rem'
//                   }}
//                   onClick={() => {
//                     setCurrentDate(new Date());
//                     toolbarProps.onNavigate('TODAY');
//                   }}
//                 >
//                   Today
//                 </button>
//                 <button
//                   style={{ 
//                     ...buttonStyle(),
//                     padding: '0.25rem 0.5rem',
//                     fontSize: '0.75rem'
//                   }}
//                   onClick={() => {
//                     const newDate = new Date(currentDate);
//                     if (calendarView === 'month') {
//                       newDate.setMonth(newDate.getMonth() + 1);
//                     } else if (calendarView === 'week') {
//                       newDate.setDate(newDate.getDate() + 7);
//                     } else {
//                       newDate.setDate(newDate.getDate() + 1);
//                     }
//                     setCurrentDate(newDate);
//                     toolbarProps.onNavigate('NEXT');
//                   }}
//                 >
//                   Next
//                 </button>
//               </div>
              
//               <span style={{ fontWeight: '600', color: '#1e293b' }}>
//                 {toolbarProps.label}
//               </span>
              
//               <div style={{ display: 'flex', gap: '0.5rem' }}>
//                 {['month', 'week', 'day', 'agenda'].map(view => (
//                   <button
//                     key={view}
//                     style={{ 
//                       ...buttonStyle(),
//                       padding: '0.25rem 0.5rem',
//                       fontSize: '0.75rem',
//                       backgroundColor: calendarView === view ? '#4338ca' : '#4f46e5'
//                     }}
//                     onClick={() => {
//                       setCalendarView(view);
//                       toolbarProps.onView(view);
//                     }}
//                   >
//                     {view.charAt(0).toUpperCase() + view.slice(1)}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )
//         }}
//       />
//     </div>
//   </div>
// </div>
//            <div style={{ marginTop: '1.5rem' }}>
//       <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem' }}>Upcoming Events</h3>
//       {events
//         .filter(event => new Date(event.end) > new Date())
//         .sort((a, b) => new Date(a.start) - new Date(b.start))
//         .slice(0, 5)
//         .map(event => (
//           <div key={event.id} style={{ 
//             padding: '0.75rem', 
//             marginBottom: '0.75rem', 
//             borderRadius: '8px', 
//             borderLeft: `4px solid ${
//               event.type === 'holiday' ? '#d32f2f' : 
//               event.type === 'exam' ? '#ff8f00' : 
//               event.type === 'meeting' ? '#9333ea' :
//               event.type === 'other' ? '#64748b' :
//               '#388e3c'
//             }`,
//             backgroundColor: '#f8fafc',
//             cursor: 'pointer',
//             ':hover': {
//               backgroundColor: '#f1f5f9'
//             }
//           }}
//           onClick={() => {
//             setNewEvent({
//               id: event.id,
//               title: event.title,
//               start: new Date(event.start),
//               end: new Date(event.end),
//               description: event.description || '',
//               type: event.type || 'event'
//             });
//             document.getElementById('event-form-section')?.scrollIntoView({ behavior: 'smooth' });
//           }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <div>
//                 <div style={{ fontWeight: '500', color: '#1e293b' }}>{event.title}</div>
//                 <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
//                   {moment(event.start).format('MMM D, YYYY h:mm A')} - {moment(event.end).format('MMM D, YYYY h:mm A')}
//                 </div>
//               </div>
//               <span style={{ 
//                 fontSize: '0.75rem', 
//                 fontWeight: '500', 
//                 padding: '0.25rem 0.5rem', 
//                 borderRadius: '9999px',
//                 backgroundColor: 
//                   event.type === 'holiday' ? '#fee2e2' : 
//                   event.type === 'exam' ? '#ffedd5' : 
//                   event.type === 'meeting' ? '#f3e8ff' :
//                   event.type === 'other' ? '#f1f5f9' :
//                   '#dcfce7',
//                 color: 
//                   event.type === 'holiday' ? '#b91c1c' : 
//                   event.type === 'exam' ? '#9a3412' : 
//                   event.type === 'meeting' ? '#6b21a8' :
//                   event.type === 'other' ? '#334155' :
//                   '#166534'
//               }}>
//                 {event.type === 'holiday' ? 'Holiday' : 
//                  event.type === 'exam' ? 'Exam' : 
//                  event.type === 'meeting' ? 'Meeting' :
//                  event.type === 'other' ? 'Other' :
//                  'Event'}
//               </span>
//             </div>
//             {event.description && (
//               <div style={{ fontSize: '0.875rem', color: '#475569', marginTop: '0.5rem' }}>
//                 {event.description}
//               </div>
//             )}
//           </div>
//         ))
//       }
      
//       {events.filter(event => new Date(event.end) > new Date()).length === 0 && (
//         <div style={{ 
//           padding: '1.5rem', 
//           textAlign: 'center', 
//           backgroundColor: '#f8fafc', 
//           borderRadius: '8px',
//           border: '1px dashed #e2e8f0'
//         }}>
//           <svg style={{ width: '2rem', height: '2rem', margin: '0 auto 0.5rem', color: '#cbd5e1' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//           </svg>
//           <p style={{ fontSize: '0.875rem', color: '#64748b' }}>No upcoming events scheduled</p>
//         </div>
//       )}
      
//       {events.length > 5 && (
//         <div style={{ textAlign: 'center', marginTop: '1rem' }}>
//           <button
//             style={{ 
//               ...buttonStyle(),
//               padding: '0.25rem 0.5rem',
//               fontSize: '0.75rem'
//             }}
//             onClick={() => {
//               // This would navigate to a full events list view
//               // You would need to implement this functionality
//               console.log('View all events');
//             }}
//           >
//             View All Events
//           </button>
//         </div>
//       )}
//     </div>
//         </div>
//       </main>
//     </div>
//   );


// };

// export default AcademicAdminDashboard;

















// import React, { useState, useEffect } from 'react';
// import { ref, push, set, onValue, remove, update } from 'firebase/database';
// import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
// import { database, storage } from '../firebase';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Localizer for calendar
// const localizer = momentLocalizer(moment);

// // Styles
// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: '#f8fafc',
//     fontFamily: "'Inter', sans-serif"
//   },
//   header: {
//     background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
//     color: 'white',
//     padding: '1.5rem 2rem',
//     boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
//   },
//   card: {
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden',
//     marginBottom: '1.5rem'
//   },
//   cardHeader: {
//     backgroundColor: '#f1f5f9',
//     borderBottom: '1px solid #e2e8f0',
//     padding: '1rem 1.5rem',
//     display: 'flex',
//     alignItems: 'center'
//   },
//   input: {
//     width: '100%',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: '1px solid #e2e8f0',
//     fontSize: '0.875rem',
//     outline: 'none',
//     transition: 'all 0.2s',
//     boxSizing: 'border-box'
//   },
//   button: (disabled = false) => ({
//     backgroundColor: disabled ? '#cbd5e1' : '#4f46e5',
//     color: 'white',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: 'none',
//     cursor: disabled ? 'not-allowed' : 'pointer',
//     fontSize: '0.875rem',
//     fontWeight: '500',
//     transition: 'all 0.2s',
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: disabled ? 'none' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//   }),
//   deleteButton: {
//     color: '#ef4444',
//     backgroundColor: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     padding: '0.25rem',
//     borderRadius: '50%',
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   fileInput: {
//     display: 'none'
//   },
//   fileInputLabel: (hasFile) => ({
//     display: 'block',
//     width: '100%',
//     padding: '0.5rem 1rem',
//     borderRadius: '8px',
//     border: `1px solid ${hasFile ? '#bfdbfe' : '#e2e8f0'}`,
//     backgroundColor: hasFile ? '#eff6ff' : 'white',
//     cursor: 'pointer',
//     fontSize: '0.875rem',
//     transition: 'all 0.2s'
//   })
// };

// // Sub-components
// const ClassManagement = ({ 
//   classes, 
//   newClassName, 
//   newClassTeacher, 
//   newClassRoom, 
//   setNewClassName, 
//   setNewClassTeacher, 
//   setNewClassRoom, 
//   addClass, 
//   deleteClass 
// }) => (
//   <div style={styles.card}>
//     <div style={styles.cardHeader}>
//       <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
//         <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
//       </svg>
//       <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Class Management</h2>
//     </div>
//     <div style={{ padding: '1.5rem' }}>
//       <div style={{ marginBottom: '1.5rem' }}>
//         <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Class Name</label>
//         <input
//           type="text"
//           style={styles.input}
//           value={newClassName}
//           onChange={(e) => setNewClassName(e.target.value)}
//           placeholder="e.g., Class 1A"
//         />
//       </div>
      
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Teacher</label>
//           <input
//             type="text"
//             style={styles.input}
//             value={newClassTeacher}
//             onChange={(e) => setNewClassTeacher(e.target.value)}
//             placeholder="Teacher's name"
//           />
//         </div>
        
//         <div>
//           <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Room</label>
//           <input
//             type="text"
//             style={styles.input}
//             value={newClassRoom}
//             onChange={(e) => setNewClassRoom(e.target.value)}
//             placeholder="Room number"
//           />
//         </div>
//       </div>
      
//       <button
//         style={styles.button(!newClassName)}
//         onClick={addClass}
//         disabled={!newClassName}
//       >
//         Create Class
//       </button>
      
//       <div style={{ marginTop: '1.5rem' }}>
//         <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
//           <svg style={{ width: '1rem', height: '1rem', marginRight: '0.5rem', color: '#64748b' }} fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
//           </svg>
//           Existing Classes
//         </h3>
//         <div style={{ display: 'grid', gap: '0.75rem' }}>
//           {classes.length > 0 ? (
//             classes.map(cls => (
//               <div key={cls.id} style={{ 
//                 padding: '0.75rem', 
//                 borderRadius: '8px', 
//                 border: '1px solid #e2e8f0', 
//                 display: 'flex', 
//                 justifyContent: 'space-between', 
//                 alignItems: 'center',
//                 transition: 'all 0.2s',
//                 ':hover': {
//                   borderColor: '#c7d2fe',
//                   backgroundColor: '#f8fafc'
//                 }
//               }}>
//                 <div>
//                   <span style={{ fontWeight: '500', color: '#1e293b' }}>{cls.name}</span>
//                   <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
//                     {cls.teacher && (
//                       <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '0.75rem' }}>
//                         <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
//                           <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
//                         </svg>
//                         {cls.teacher}
//                       </span>
//                     )}
//                     {cls.room && (
//                       <span style={{ display: 'inline-flex', alignItems: 'center' }}>
//                         <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
//                           <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
//                         </svg>
//                         Room {cls.room}
//                       </span>
//                     )}
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => deleteClass(cls.id)}
//                   style={styles.deleteButton}
//                   title="Delete class"
//                 >
//                   <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                   </svg>
//                 </button>
//               </div>
//             ))
//           ) : (
//             <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
//               <svg style={{ width: '3rem', height: '3rem', margin: '0 auto', color: '#cbd5e1' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//               </svg>
//               <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.5rem' }}>No classes added yet</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   </div>
// );

// const AcademicContent = ({ 
//   classes, 
//   selectedClass, 
//   setSelectedClass, 
//   selectedYear, 
//   setSelectedYear, 
//   planFile, 
//   setPlanFile, 
//   uploadingPlan, 
//   uploadYearlyPlan, 
//   existingPlans, 
//   deletePlan,
//   syllabusFile,
//   setSyllabusFile,
//   uploadingSyllabus,
//   uploadSyllabus,
//   existingSyllabi,
//   deleteSyllabus,
//   examTimetableFile,
//   setExamTimetableFile,
//   uploadingExamTimetable,
//   uploadExamTimetable,
//   existingExamTimetables,
//   deleteExamTimetable,
//   newExam,
//   setNewExam
// }) => (
//   <div style={styles.card}>
//     <div style={styles.cardHeader}>
//       <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
//         <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//       </svg>
//       <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Academic Content</h2>
//     </div>
//     <div style={{ padding: '1.5rem' }}>
//       <div style={{ marginBottom: '1.5rem' }}>
//         <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Select Class</label>
//         <select
//           style={styles.input}
//           value={selectedClass}
//           onChange={(e) => setSelectedClass(e.target.value)}
//         >
//           <option value="">Choose a class...</option>
//           {classes.map(cls => (
//             <option key={cls.id} value={cls.id}>{cls.name}</option>
//           ))}
//         </select>
//       </div>
      
//       {selectedClass && (
//         <div style={{ display: 'grid', gap: '1.5rem' }}>
//           {/* Yearly Plan Section */}
//           <div style={{ 
//             ...styles.card, 
//             backgroundColor: '#f0f9ff',
//             border: '1px solid #bfdbfe'
//           }}>
//             <div style={{ 
//               ...styles.cardHeader, 
//               backgroundColor: '#e0f2fe',
//               borderBottom: '1px solid #bfdbfe'
//             }}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#0369a1' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z" clipRule="evenodd" />
//               </svg>
//               <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#0369a1' }}>Yearly Plan</h3>
//             </div>
//             <div style={{ padding: '1rem' }}>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Academic Year</label>
//                   <input
//                     type="number"
//                     style={styles.input}
//                     value={selectedYear}
//                     onChange={(e) => setSelectedYear(e.target.value)}
//                     min="2000"
//                     max="2100"
//                   />
//                 </div>
                
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Plan File</label>
//                   <div style={{ display: 'flex', alignItems: 'center' }}>
//                     <label style={styles.fileInputLabel(planFile)}>
//                       {planFile ? planFile.name : 'Choose file...'}
//                       <input
//                         type="file"
//                         style={styles.fileInput}
//                         onChange={(e) => setPlanFile(e.target.files[0])}
//                         accept=".pdf,.doc,.docx"
//                       />
//                     </label>
//                     {planFile && (
//                       <button 
//                         onClick={() => setPlanFile(null)}
//                         style={{ 
//                           marginLeft: '0.5rem', 
//                           padding: '0.25rem', 
//                           color: '#ef4444', 
//                           backgroundColor: 'transparent', 
//                           border: 'none', 
//                           cursor: 'pointer',
//                           borderRadius: '50%'
//                         }}
//                         title="Remove file"
//                       >
//                         <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                         </svg>
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
              
//               <button
//                 style={styles.button(uploadingPlan || !planFile)}
//                 onClick={uploadYearlyPlan}
//                 disabled={uploadingPlan || !planFile}
//               >
//                 {uploadingPlan ? (
//                   <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Uploading...
//                   </span>
//                 ) : 'Upload Plan'}
//               </button>
              
//               {existingPlans.length > 0 && (
//                 <div style={{ marginTop: '1rem' }}>
//                   <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Existing Plans:</h4>
//                   <div style={{ display: 'grid', gap: '0.5rem' }}>
//                     {existingPlans.map(plan => (
//                       <div key={plan.id} style={{ 
//                         padding: '0.75rem', 
//                         borderRadius: '8px', 
//                         backgroundColor: 'white', 
//                         border: '1px solid #e2e8f0',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center'
//                       }}>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                           <svg style={{ width: '1.25rem', height: '1.25rem', color: '#3b82f6', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm4-1a1 1 0 10-2 0v4a1 1 0 102 0V8z" clipRule="evenodd" />
//                           </svg>
//                           <div>
//                             <span style={{ fontWeight: '500', color: '#1e293b' }}>{plan.year}</span>
//                             <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{plan.fileName}</span>
//                           </div>
//                         </div>
//                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                           <a 
//                             href={plan.fileUrl} 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#3b82f6', 
//                               backgroundColor: '#eff6ff', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center'
//                             }}
//                             title="View"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                             </svg>
//                           </a>
//                           <button
//                             onClick={() => deletePlan(plan)}
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#ef4444', 
//                               backgroundColor: '#fef2f2', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               border: 'none',
//                               cursor: 'pointer'
//                             }}
//                             title="Delete"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
          
//           {/* Syllabus Section */}
//           <div style={{ 
//             ...styles.card, 
//             backgroundColor: '#ecfdf5',
//             border: '1px solid #a7f3d0'
//           }}>
//             <div style={{ 
//               ...styles.cardHeader, 
//               backgroundColor: '#d1fae5',
//               borderBottom: '1px solid #a7f3d0'
//             }}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#047857' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
//               </svg>
//               <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#047857' }}>Class Syllabus</h3>
//             </div>
//             <div style={{ padding: '1rem' }}>
//               <div style={{ marginBottom: '1rem' }}>
//                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Syllabus File</label>
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                   <label style={styles.fileInputLabel(syllabusFile)}>
//                     {syllabusFile ? syllabusFile.name : 'Choose file...'}
//                     <input
//                       type="file"
//                       style={styles.fileInput}
//                       onChange={(e) => setSyllabusFile(e.target.files[0])}
//                       accept=".pdf,.doc,.docx"
//                     />
//                   </label>
//                   {syllabusFile && (
//                     <button 
//                       onClick={() => setSyllabusFile(null)}
//                       style={{ 
//                         marginLeft: '0.5rem', 
//                         padding: '0.25rem', 
//                         color: '#ef4444', 
//                         backgroundColor: 'transparent', 
//                         border: 'none', 
//                         cursor: 'pointer',
//                         borderRadius: '50%'
//                       }}
//                       title="Remove file"
//                     >
//                       <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
              
//               <button
//                 style={styles.button(uploadingSyllabus || !syllabusFile)}
//                 onClick={uploadSyllabus}
//                 disabled={uploadingSyllabus || !syllabusFile}
//               >
//                 {uploadingSyllabus ? (
//                   <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Uploading...
//                   </span>
//                 ) : 'Upload Syllabus'}
//               </button>
              
//               {existingSyllabi.length > 0 && (
//                 <div style={{ marginTop: '1rem' }}>
//                   <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Current Syllabus:</h4>
//                   <div style={{ display: 'grid', gap: '0.5rem' }}>
//                     {existingSyllabi.map(syllabus => (
//                       <div key={syllabus.id} style={{ 
//                         padding: '0.75rem', 
//                         borderRadius: '8px', 
//                         backgroundColor: 'white', 
//                         border: '1px solid #e2e8f0',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center'
//                       }}>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                           <svg style={{ width: '1.25rem', height: '1.25rem', color: '#10b981', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//                           </svg>
//                           <span style={{ fontSize: '0.875rem' }}>{syllabus.fileName}</span>
//                         </div>
//                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                           <a 
//                             href={syllabus.fileUrl} 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#10b981', 
//                               backgroundColor: '#ecfdf5', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center'
//                             }}
//                             title="View"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                             </svg>
//                           </a>
//                           <button
//                             onClick={() => deleteSyllabus(syllabus)}
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#ef4444', 
//                               backgroundColor: '#fef2f2', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               border: 'none',
//                               cursor: 'pointer'
//                             }}
//                             title="Delete"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
          
//           {/* Exam Timetable Section */}
//           <div style={{ 
//             ...styles.card, 
//             backgroundColor: '#f5f3ff',
//             border: '1px solid #c4b5fd'
//           }}>
//             <div style={{ 
//               ...styles.cardHeader, 
//               backgroundColor: '#ede9fe',
//               borderBottom: '1px solid #c4b5fd'
//             }}>
//               <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#7c3aed' }} fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
//               </svg>
//               <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#7c3aed' }}>Exam Timetable</h3>
//             </div>
//             <div style={{ padding: '1rem' }}>
//               <div style={{ marginBottom: '1rem' }}>
//                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Exam Name</label>
//                 <input
//                   type="text"
//                   style={styles.input}
//                   value={newExam.name}
//                   onChange={(e) => setNewExam({...newExam, name: e.target.value})}
//                   placeholder="e.g., Mid-Term Exams"
//                 />
//               </div>
              
//               <div style={{ marginBottom: '1rem' }}>
//                 <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Timetable File</label>
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                   <label style={styles.fileInputLabel(examTimetableFile)}>
//                     {examTimetableFile ? examTimetableFile.name : 'Choose file...'}
//                     <input
//                       type="file"
//                       style={styles.fileInput}
//                       onChange={(e) => setExamTimetableFile(e.target.files[0])}
//                       accept=".pdf,.doc,.docx,.jpg,.png"
//                     />
//                   </label>
//                   {examTimetableFile && (
//                     <button 
//                       onClick={() => setExamTimetableFile(null)}
//                       style={{ 
//                         marginLeft: '0.5rem', 
//                         padding: '0.25rem', 
//                         color: '#ef4444', 
//                         backgroundColor: 'transparent', 
//                         border: 'none', 
//                         cursor: 'pointer',
//                         borderRadius: '50%'
//                       }}
//                       title="Remove file"
//                     >
//                       <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
              
//               <button
//                 style={styles.button(uploadingExamTimetable || !examTimetableFile)}
//                 onClick={uploadExamTimetable}
//                 disabled={uploadingExamTimetable || !examTimetableFile}
//               >
//                 {uploadingExamTimetable ? (
//                   <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Uploading...
//                   </span>
//                 ) : 'Upload Timetable'}
//               </button>
              
//               {existingExamTimetables.length > 0 && (
//                 <div style={{ marginTop: '1rem' }}>
//                   <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Uploaded Timetables:</h4>
//                   <div style={{ display: 'grid', gap: '0.5rem' }}>
//                     {existingExamTimetables.map(timetable => (
//                       <div key={timetable.id} style={{ 
//                         padding: '0.75rem', 
//                         borderRadius: '8px', 
//                         backgroundColor: 'white', 
//                         border: '1px solid #e2e8f0',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center'
//                       }}>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                           <svg style={{ width: '1.25rem', height: '1.25rem', color: '#7c3aed', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//                           </svg>
//                           <div>
//                             <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>{timetable.examName || 'Exam Timetable'}</span>
//                             <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{timetable.fileName}</span>
//                           </div>
//                         </div>
//                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                           <a 
//                             href={timetable.fileUrl} 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#7c3aed', 
//                               backgroundColor: '#ede9fe', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center'
//                             }}
//                             title="View"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                             </svg>
//                           </a>
//                           <button
//                             onClick={() => deleteExamTimetable(timetable)}
//                             style={{ 
//                               padding: '0.25rem', 
//                               color: '#ef4444', 
//                               backgroundColor: '#fef2f2', 
//                               borderRadius: '50%',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               border: 'none',
//                               cursor: 'pointer'
//                             }}
//                             title="Delete"
//                           >
//                             <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   </div>
// );

// // const SchoolCalendar = ({ 
// //   events, 
// //   newEvent, 
// //   setNewEvent, 
// //   addCalendarEvent, 
// //   updateCalendarEvent, 
// //   deleteEvent, 
// //   calendarView, 
// //   setCalendarView, 
// //   currentDate, 
// //   setCurrentDate 
// // }) => {
// //   const eventStyleGetter = (event) => {
// //     let backgroundColor = '#3174ad';
// //     if (event.type === 'holiday') backgroundColor = '#d32f2f';
// //     if (event.type === 'exam') backgroundColor = '#ff8f00';
// //     if (event.type === 'event') backgroundColor = '#388e3c';
    
// //     return {
// //       style: {
// //         backgroundColor,
// //         borderRadius: '4px',
// //         opacity: 0.8,
// //         color: 'white',
// //         border: '0px',
// //         display: 'block'
// //       }
// //     };
// //   };

// //   return (
// //     <div style={{ ...styles.card, gridColumn: '1 / -1' }}>
// //       <div style={styles.cardHeader}>
// //         <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
// //           <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
// //         </svg>
// //         <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>School Calendar</h2>
// //       </div>
// //       <div style={{ padding: '1.5rem' }}>
// //         <div style={{ marginBottom: '1.5rem' }} id="event-form-section">
// //           <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem' }}>
// //             {newEvent.id ? 'Edit Event' : 'Add New Event'}
// //           </h3>
// //           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
// //             <div>
// //               <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Event Title</label>
// //               <input
// //                 type="text"
// //                 style={styles.input}
// //                 value={newEvent.title}
// //                 onChange={(e) => setNewEvent({...newEvent, title: e.target.value})}
// //               />
// //             </div>
            
// //             <div>
// //               <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Event Type</label>
// //               <select
// //                 style={styles.input}
// //                 value={newEvent.type}
// //                 onChange={(e) => setNewEvent({...newEvent, type: e.target.value})}
// //               >
// //                 <option value="holiday">Holiday</option>
// //                 <option value="exam">Exam</option>
// //                 <option value="event">School Event</option>
// //               </select>
// //             </div>
            
// //             <div>
// //               <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Start Date & Time</label>
// //               <input
// //                 type="datetime-local"
// //                 style={styles.input}
// //                 value={moment(newEvent.start).format('YYYY-MM-DDTHH:mm')}
// //                 onChange={(e) => setNewEvent({...newEvent, start: new Date(e.target.value)})}
// //               />
// //             </div>
            
// //             <div>
// //               <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>End Date & Time</label>
// //               <input
// //                 type="datetime-local"
// //                 style={styles.input}
// //                 value={moment(newEvent.end).format('YYYY-MM-DDTHH:mm')}
// //                 onChange={(e) => setNewEvent({...newEvent, end: new Date(e.target.value)})}
// //               />
// //             </div>
            
// //             <div style={{ gridColumn: '1 / -1' }}>
// //               <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Description</label>
// //               <textarea
// //                 style={{ ...styles.input, minHeight: '5rem' }}
// //                 value={newEvent.description}
// //                 onChange={(e) => setNewEvent({...newEvent, description: e.target.value})}
// //               />
// //             </div>
            
// //             <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
// //               {newEvent.id && (
// //                 <button
// //                   style={{ 
// //                     ...styles.button(),
// //                     padding: '0.5rem 1.5rem',
// //                     backgroundColor: '#ef4444',
// //                     ':hover': {
// //                       backgroundColor: '#dc2626'
// //                     }
// //                   }}
// //                   onClick={() => {
// //                     if (window.confirm('Are you sure you want to delete this event?')) {
// //                       deleteEvent(newEvent.id);
// //                     }
// //                   }}
// //                 >
// //                   Delete Event
// //                 </button>
// //               )}
// //               {newEvent.id && (
// //                 <button
// //                   style={{ 
// //                     ...styles.button(),
// //                     padding: '0.5rem 1.5rem',
// //                     backgroundColor: '#64748b',
// //                     ':hover': {
// //                       backgroundColor: '#475569'
// //                     }
// //                   }}
// //                   onClick={() => {
// //                     setNewEvent({
// //                       title: '',
// //                       start: new Date(),
// //                       end: new Date(),
// //                       description: '',
// //                       type: 'holiday'
// //                     });
// //                   }}
// //                 >
// //                   Cancel
// //                 </button>
// //               )}
// //               <button
// //                 style={{ 
// //                   ...styles.button(),
// //                   padding: '0.5rem 1.5rem',
// //                   backgroundColor: '#4f46e5',
// //                   ':hover': {
// //                     backgroundColor: '#4338ca'
// //                   }
// //                 }}
// //                 onClick={newEvent.id ? updateCalendarEvent : addCalendarEvent}
// //               >
// //                 {newEvent.id ? 'Update Event' : 'Add to Calendar'}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
        
// //         <div style={{ height: '600px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
// //           <Calendar
// //             localizer={localizer}
// //             events={events}
// //             startAccessor="start"
// //             endAccessor="end"
// //             style={{ height: '100%' }}
// //             eventPropGetter={eventStyleGetter}
// //             onSelectEvent={(event) => {
// //               setNewEvent({
// //                 id: event.id,
// //                 title: event.title,
// //                 start: new Date(event.start),
// //                 end: new Date(event.end),
// //                 description: event.description || '',
// //                 type: event.type || 'event'
// //               });
// //               document.getElementById('event-form-section')?.scrollIntoView({ behavior: 'smooth' });
// //             }}
// //             selectable
// //             views={['month', 'week', 'day', 'agenda']}
// //             view={calendarView}
// //             onView={(view) => setCalendarView(view)}
// //             date={currentDate}
// //             onNavigate={(date) => {
// //               setCurrentDate(date);
// //             }}
// //             components={{
// //               event: ({ event }) => (
// //                 <div style={{ 
// //                   padding: '0.25rem',
// //                   whiteSpace: 'nowrap',
// //                   overflow: 'hidden',
// //                   textOverflow: 'ellipsis'
// //                 }}>
// //                   <strong>{event.title}</strong>
// //                   {event.description && (
// //                     <p style={{ fontSize: '0.75rem', marginTop: '0.25rem', whiteSpace: 'normal' }}>
// //                       {event.description}
// //                     </p>
// //                   )}
// //                 </div>
// //               ),
// //               toolbar: (toolbarProps) => (
// //                 <div style={{ 
// //                   display: 'flex', 
// //                   justifyContent: 'space-between', 
// //                   alignItems: 'center',
// //                   padding: '0.5rem',
// //                   backgroundColor: '#f8fafc',
// //                   borderBottom: '1px solid #e2e8f0'
// //                 }}>
// //                   <div style={{ display: 'flex', gap: '0.5rem' }}>
// //                     <button
// //                       style={{ 
// //                         ...styles.button(),
// //                         padding: '0.25rem 0.5rem',
// //                         fontSize: '0.75rem'
// //                       }}
// //                       onClick={() => {
// //                         const newDate = new Date(currentDate);
// //                         if (calendarView === 'month') {
// //                           newDate.setMonth(newDate.getMonth() - 1);
// //                         } else if (calendarView === 'week') {
// //                           newDate.setDate(newDate.getDate() - 7);
// //                         } else {
// //                           newDate.setDate(newDate.getDate() - 1);
// //                         }
// //                         setCurrentDate(newDate);
// //                         toolbarProps.onNavigate('PREV');
// //                       }}
// //                     >
// //                       Back
// //                     </button>
// //                     <button
// //                       style={{ 
// //                         ...styles.button(),
// //                         padding: '0.25rem 0.5rem',
// //                         fontSize: '0.75rem'
// //                       }}
// //                       onClick={() => {
// //                         setCurrentDate(new Date());
// //                         toolbarProps.onNavigate('TODAY');
// //                       }}
// //                     >
// //                       Today
// //                     </button>
// //                     <button
// //                       style={{ 
// //                         ...styles.button(),
// //                         padding: '0.25rem 0.5rem',
// //                         fontSize: '0.75rem'
// //                       }}
// //                       onClick={() => {
// //                         const newDate = new Date(currentDate);
// //                         if (calendarView === 'month') {
// //                           newDate.setMonth(newDate.getMonth() + 1);
// //                         } else if (calendarView === 'week') {
// //                           newDate.setDate(newDate.getDate() + 7);
// //                         } else {
// //                           newDate.setDate(newDate.getDate() + 1);
// //                         }
// //                         setCurrentDate(newDate);
// //                         toolbarProps.onNavigate('NEXT');
// //                       }}
// //                     >
// //                       Next
// //                     </button>
// //                   </div>
                  
// //                   <span style={{ fontWeight: '600', color: '#1e293b' }}>
// //                     {toolbarProps.label}
// //                   </span>
                  
// //                   <div style={{ display: 'flex', gap: '0.5rem' }}>
// //                     {['month', 'week', 'day', 'agenda'].map(view => (
// //                       <button
// //                         key={view}
// //                         style={{ 
// //                           ...styles.button(),
// //                           padding: '0.25rem 0.5rem',
// //                           fontSize: '0.75rem',
// //                           backgroundColor: calendarView === view ? '#4338ca' : '#4f46e5'
// //                         }}
// //                         onClick={() => {
// //                           setCalendarView(view);
// //                           toolbarProps.onView(view);
// //                         }}
// //                       >
// //                         {view.charAt(0).toUpperCase() + view.slice(1)}
// //                       </button>
// //                     ))}
// //                   </div>
// //                 </div>
// //               )
// //             }}
// //           />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // const UpcomingEvents = ({ events, setNewEvent }) => (
// //   <div style={{ marginTop: '1.5rem' }}>
// //     <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem' }}>Upcoming Events</h3>
// //     {events
// //       .filter(event => new Date(event.end) > new Date())
// //       .sort((a, b) => new Date(a.start) - new Date(b.start))
// //       .slice(0, 5)
// //       .map(event => (
// //         <div key={event.id} style={{ 
// //           padding: '0.75rem', 
// //           marginBottom: '0.75rem', 
// //           borderRadius: '8px', 
// //           borderLeft: `4px solid ${
// //             event.type === 'holiday' ? '#d32f2f' : 
// //             event.type === 'exam' ? '#ff8f00' : 
// //             event.type === 'meeting' ? '#9333ea' :
// //             event.type === 'other' ? '#64748b' :
// //             '#388e3c'
// //           }`,
// //           backgroundColor: '#f8fafc',
// //           cursor: 'pointer',
// //           ':hover': {
// //             backgroundColor: '#f1f5f9'
// //           }
// //         }}
// //         onClick={() => {
// //           setNewEvent({
// //             id: event.id,
// //             title: event.title,
// //             start: new Date(event.start),
// //             end: new Date(event.end),
// //             description: event.description || '',
// //             type: event.type || 'event'
// //           });
// //           document.getElementById('event-form-section')?.scrollIntoView({ behavior: 'smooth' });
// //         }}>
// //           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //             <div>
// //               <div style={{ fontWeight: '500', color: '#1e293b' }}>{event.title}</div>
// //               <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
// //                 {moment(event.start).format('MMM D, YYYY h:mm A')} - {moment(event.end).format('MMM D, YYYY h:mm A')}
// //               </div>
// //             </div>
// //             <span style={{ 
// //               fontSize: '0.75rem', 
// //               fontWeight: '500', 
// //               padding: '0.25rem 0.5rem', 
// //               borderRadius: '9999px',
// //               backgroundColor: 
// //                 event.type === 'holiday' ? '#fee2e2' : 
// //                 event.type === 'exam' ? '#ffedd5' : 
// //                 event.type === 'meeting' ? '#f3e8ff' :
// //                 event.type === 'other' ? '#f1f5f9' :
// //                 '#dcfce7',
// //               color: 
// //                 event.type === 'holiday' ? '#b91c1c' : 
// //                 event.type === 'exam' ? '#9a3412' : 
// //                 event.type === 'meeting' ? '#6b21a8' :
// //                 event.type === 'other' ? '#334155' :
// //                 '#166534'
// //             }}>
// //               {event.type === 'holiday' ? 'Holiday' : 
// //                event.type === 'exam' ? 'Exam' : 
// //                event.type === 'meeting' ? 'Meeting' :
// //                event.type === 'other' ? 'Other' :
// //                'Event'}
// //             </span>
// //           </div>
// //           {event.description && (
// //             <div style={{ fontSize: '0.875rem', color: '#475569', marginTop: '0.5rem' }}>
// //               {event.description}
// //             </div>
// //           )}
// //         </div>
// //       ))
// //     }
    
// //     {events.filter(event => new Date(event.end) > new Date()).length === 0 && (
// //       <div style={{ 
// //         padding: '1.5rem', 
// //         textAlign: 'center', 
// //         backgroundColor: '#f8fafc', 
// //         borderRadius: '8px',
// //         border: '1px dashed #e2e8f0'
// //       }}>
// //         <svg style={{ width: '2rem', height: '2rem', margin: '0 auto 0.5rem', color: '#cbd5e1' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
// //         </svg>
// //         <p style={{ fontSize: '0.875rem', color: '#64748b' }}>No upcoming events scheduled</p>
// //       </div>
// //     )}
    
// //     {events.length > 5 && (
// //       <div style={{ textAlign: 'center', marginTop: '1rem' }}>
// //         <button
// //           style={{ 
// //             ...styles.button(),
// //             padding: '0.25rem 0.5rem',
// //             fontSize: '0.75rem'
// //           }}
// //           onClick={() => {
// //             // This would navigate to a full events list view
// //             // You would need to implement this functionality
// //             console.log('View all events');
// //           }}
// //         >
// //           View All Events
// //         </button>
// //       </div>
// //     )}
// //   </div>
// // );

// // Main Component
// const AcademicAdminDashboard = () => {
//   // State for Classes Management
//   const [classes, setClasses] = useState([]);
//   const [newClassName, setNewClassName] = useState('');
//   const [newClassTeacher, setNewClassTeacher] = useState('');
//   const [newClassRoom, setNewClassRoom] = useState('');

//   // State for Yearly Plans
//   const [selectedClass, setSelectedClass] = useState('');
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [planFile, setPlanFile] = useState(null);
//   const [uploadingPlan, setUploadingPlan] = useState(false);
//   const [existingPlans, setExistingPlans] = useState([]);

//   // State for Syllabus Management
//   const [syllabusFile, setSyllabusFile] = useState(null);
//   const [uploadingSyllabus, setUploadingSyllabus] = useState(false);
//   const [existingSyllabi, setExistingSyllabi] = useState([]);

//   // State for Exam Timetables
//   const [examTimetableFile, setExamTimetableFile] = useState(null);
//   const [uploadingExamTimetable, setUploadingExamTimetable] = useState(false);
//   const [existingExamTimetables, setExistingExamTimetables] = useState([]);

//   // State for Exams Management
//   const [exams, setExams] = useState([]);
//   const [newExam, setNewExam] = useState({
//     name: '',
//     date: new Date().toISOString().split('T')[0],
//     description: '',
//     syllabusCovered: ''
//   });

//   // State for School Calendar
//   const [events, setEvents] = useState([]);
//   const [newEvent, setNewEvent] = useState({
//     title: '',
//     start: new Date(),
//     end: new Date(),
//     description: '',
//     type: 'holiday'
//   });

//   const [calendarView, setCalendarView] = useState('month');
//   const [currentDate, setCurrentDate] = useState(new Date());

//   // Fetch all classes
//   useEffect(() => {
//     const classesRef = ref(database, 'school/classes');
//     onValue(classesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const classesArray = Object.entries(data).map(([id, classData]) => ({
//           id,
//           ...classData
//         }));
//         setClasses(classesArray);
//       }
//     });
//   }, []);

//   // Fetch existing yearly plans when class is selected
//   useEffect(() => {
//     if (selectedClass) {
//       const plansRef = ref(database, `school/academic/${selectedClass}/yearlyPlans`);
//       onValue(plansRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const plansArray = Object.entries(data).map(([id, plan]) => ({
//             id,
//             ...plan
//           }));
//           setExistingPlans(plansArray);
//         } else {
//           setExistingPlans([]);
//         }
//       });
//     }
//   }, [selectedClass]);

//   // Fetch existing syllabi when class is selected
//   useEffect(() => {
//     if (selectedClass) {
//       const syllabiRef = ref(database, `school/academic/${selectedClass}/syllabus`);
//       onValue(syllabiRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const syllabiArray = Object.entries(data).map(([id, syllabus]) => ({
//             id,
//             ...syllabus
//           }));
//           setExistingSyllabi(syllabiArray);
//         } else {
//           setExistingSyllabi([]);
//         }
//       });
//     }
//   }, [selectedClass]);

//   // Fetch exam timetables when class is selected
//   useEffect(() => {
//     if (selectedClass) {
//       const timetablesRef = ref(database, `school/academic/${selectedClass}/examTimetables`);
//       onValue(timetablesRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const timetablesArray = Object.entries(data).map(([id, timetable]) => ({
//             id,
//             ...timetable
//           }));
//           setExistingExamTimetables(timetablesArray);
//         } else {
//           setExistingExamTimetables([]);
//         }
//       });
//     }
//   }, [selectedClass]);

//   // Fetch calendar events
//   useEffect(() => {
//     const eventsRef = ref(database, 'school/academic/calendar');
//     onValue(eventsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const eventsArray = Object.entries(data).map(([id, event]) => ({
//           id,
//           ...event,
//           start: new Date(event.start),
//           end: new Date(event.end)
//         }));
//         setEvents(eventsArray);
//       } else {
//         setEvents([]);
//       }
//     });
//   }, []);

//   // Add new class
//   const addClass = async () => {
//     if (!newClassName) {
//       alert('Please enter class name');
//       return;
//     }

//     try {
//       const classRef = push(ref(database, 'school/classes'));
//       await set(classRef, {
//         name: newClassName,
//         teacher: newClassTeacher,
//         room: newClassRoom,
//         createdAt: new Date().toISOString()
//       });

//       setNewClassName('');
//       setNewClassTeacher('');
//       setNewClassRoom('');
//     } catch (error) {
//       console.error('Error adding class:', error);
//       alert('Failed to add class');
//     }
//   };

//   // Delete class
//   const deleteClass = async (classId) => {
//     if (window.confirm('Are you sure you want to delete this class and all its academic data?')) {
//       try {
//         // Delete class record
//         await remove(ref(database, `school/classes/${classId}`));
        
//         // Delete academic data
//         await remove(ref(database, `school/academic/${classId}`));
        
//         alert('Class deleted successfully');
//       } catch (error) {
//         console.error('Error deleting class:', error);
//         alert('Failed to delete class');
//       }
//     }
//   };

//   // Upload Yearly Plan
//   const uploadYearlyPlan = async () => {
//     if (!selectedClass || !planFile) {
//       alert('Please select a class and file');
//       return;
//     }

//     try {
//       setUploadingPlan(true);
      
//       // Upload file to storage
//       const filePath = `academic/${selectedClass}/plans/${selectedYear}-${Date.now()}`;
//       const fileRef = storageRef(storage, filePath);
//       await uploadBytes(fileRef, planFile);
//       const downloadURL = await getDownloadURL(fileRef);

//       // Save to database
//       const planRef = push(ref(database, `school/academic/${selectedClass}/yearlyPlans`));
//       await set(planRef, {
//         year: selectedYear,
//         fileUrl: downloadURL,
//         fileName: planFile.name,
//         storagePath: filePath,
//         uploadedAt: new Date().toISOString()
//       });

//       alert('Yearly plan uploaded successfully!');
//       setPlanFile(null);
//     } catch (error) {
//       console.error('Error uploading plan:', error);
//       alert('Failed to upload plan');
//     } finally {
//       setUploadingPlan(false);
//     }
//   };

//   // Delete Yearly Plan
//   const deletePlan = async (plan) => {
//     if (window.confirm('Are you sure you want to delete this plan?')) {
//       try {
//         // Delete from storage
//         if (plan.storagePath) {
//           const fileRef = storageRef(storage, plan.storagePath);
//           await deleteObject(fileRef);
//         }

//         // Delete from database
//         await remove(ref(database, `school/academic/${selectedClass}/yearlyPlans/${plan.id}`));
        
//         alert('Plan deleted successfully');
//       } catch (error) {
//         console.error('Error deleting plan:', error);
//         alert('Failed to delete plan');
//       }
//     }
//   };

//   // Upload Syllabus
//   const uploadSyllabus = async () => {
//     if (!selectedClass || !syllabusFile) {
//       alert('Please select a class and file');
//       return;
//     }

//     try {
//       setUploadingSyllabus(true);
      
//       // Upload file to storage
//       const filePath = `academic/${selectedClass}/syllabus/${Date.now()}`;
//       const fileRef = storageRef(storage, filePath);
//       await uploadBytes(fileRef, syllabusFile);
//       const downloadURL = await getDownloadURL(fileRef);

//       // Save to database
//       const syllabusRef = push(ref(database, `school/academic/${selectedClass}/syllabus`));
//       await set(syllabusRef, {
//         fileUrl: downloadURL,
//         fileName: syllabusFile.name,
//         storagePath: filePath,
//         uploadedAt: new Date().toISOString()
//       });

//       alert('Syllabus uploaded successfully!');
//       setSyllabusFile(null);
//     } catch (error) {
//       console.error('Error uploading syllabus:', error);
//       alert('Failed to upload syllabus');
//     } finally {
//       setUploadingSyllabus(false);
//     }
//   };

//   // Delete Syllabus
//   const deleteSyllabus = async (syllabus) => {
//     if (window.confirm('Are you sure you want to delete this syllabus?')) {
//       try {
//         // Delete from storage
//         if (syllabus.storagePath) {
//           const fileRef = storageRef(storage, syllabus.storagePath);
//           await deleteObject(fileRef);
//         }

//         // Delete from database
//         await remove(ref(database, `school/academic/${selectedClass}/syllabus/${syllabus.id}`));
        
//         alert('Syllabus deleted successfully');
//       } catch (error) {
//         console.error('Error deleting syllabus:', error);
//         alert('Failed to delete syllabus');
//       }
//     }
//   };

//   // Upload Exam Timetable
//   const uploadExamTimetable = async () => {
//     if (!selectedClass || !examTimetableFile) {
//       alert('Please select a class and file');
//       return;
//     }

//     try {
//       setUploadingExamTimetable(true);
      
//       // Upload file to storage
//       const filePath = `academic/${selectedClass}/examTimetables/${Date.now()}`;
//       const fileRef = storageRef(storage, filePath);
//       await uploadBytes(fileRef, examTimetableFile);
//       const downloadURL = await getDownloadURL(fileRef);

//       // Save to database
//       const timetableRef = push(ref(database, `school/academic/${selectedClass}/examTimetables`));
//       await set(timetableRef, {
//         fileUrl: downloadURL,
//         fileName: examTimetableFile.name,
//         storagePath: filePath,
//         uploadedAt: new Date().toISOString(),
//         examName: newExam.name || 'General Timetable'
//       });

//       alert('Exam timetable uploaded successfully!');
//       setExamTimetableFile(null);
//     } catch (error) {
//       console.error('Error uploading timetable:', error);
//       alert('Failed to upload timetable');
//     } finally {
//       setUploadingExamTimetable(false);
//     }
//   };

//   // Delete Exam Timetable
//   const deleteExamTimetable = async (timetable) => {
//     if (window.confirm('Are you sure you want to delete this exam timetable?')) {
//       try {
//         // Delete from storage
//         if (timetable.storagePath) {
//           const fileRef = storageRef(storage, timetable.storagePath);
//           await deleteObject(fileRef);
//         }

//         // Delete from database
//         await remove(ref(database, `school/academic/${selectedClass}/examTimetables/${timetable.id}`));
        
//         alert('Exam timetable deleted successfully');
//       } catch (error) {
//         console.error('Error deleting timetable:', error);
//         alert('Failed to delete timetable');
//       }
//     }
//   };

//   // // Add Calendar Event
//   // const addCalendarEvent = async () => {
//   //   if (!newEvent.title) {
//   //     alert('Please enter event title');
//   //     return;
//   //   }

//   //   try {
//   //     const eventRef = push(ref(database, 'school/academic/calendar'));
//   //     await set(eventRef, {
//   //       ...newEvent,
//   //       start: newEvent.start.toISOString(),
//   //       end: newEvent.end.toISOString()
//   //     });

//   //     setNewEvent({
//   //       title: '',
//   //       start: new Date(),
//   //       end: new Date(),
//   //       description: '',
//   //       type: 'holiday'
//   //     });
//   //   } catch (error) {
//   //     console.error('Error adding event:', error);
//   //     alert('Failed to add event');
//   //   }
//   // };

//   // // Update Calendar Event
//   // const updateCalendarEvent = async () => {
//   //   if (!newEvent.title) {
//   //     alert('Please enter event title');
//   //     return;
//   //   }

//   //   try {
//   //     await update(ref(database, `school/academic/calendar/${newEvent.id}`), {
//   //       ...newEvent,
//   //       start: newEvent.start.toISOString(),
//   //       end: newEvent.end.toISOString()
//   //     });

//   //     setNewEvent({
//   //       title: '',
//   //       start: new Date(),
//   //       end: new Date(),
//   //       description: '',
//   //       type: 'holiday'
//   //     });
//   //     alert('Event updated successfully!');
//   //   } catch (error) {
//   //     console.error('Error updating event:', error);
//   //     alert('Failed to update event');
//   //   }
//   // };

//   // // Delete Calendar Event
//   // const deleteEvent = async (eventId) => {
//   //   if (window.confirm('Are you sure you want to delete this event?')) {
//   //     try {
//   //       await remove(ref(database, `school/academic/calendar/${eventId}`));
//   //     } catch (error) {
//   //       console.error('Error deleting event:', error);
//   //       alert('Failed to delete event');
//   //     }
//   //   }
//   // };

//   return (
//     <div style={styles.container}>
//       {/* Header */}
//       <header style={styles.header}>
//         <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>Academic Administration</h1>
//         <p style={{ margin: '0.25rem 0 0', opacity: 0.9, fontSize: '0.875rem' }}>
//           Manage classes, curriculum, and school calendar
//         </p>
//       </header>

//       <main style={{ maxWidth: '1200px', margin: '2rem auto 0', padding: '0 1.5rem 2rem' }}>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
//           <ClassManagement 
//             classes={classes}
//             newClassName={newClassName}
//             newClassTeacher={newClassTeacher}
//             newClassRoom={newClassRoom}
//             setNewClassName={setNewClassName}
//             setNewClassTeacher={setNewClassTeacher}
//             setNewClassRoom={setNewClassRoom}
//             addClass={addClass}
//             deleteClass={deleteClass}
//           />

//           <AcademicContent
//             classes={classes}
//             selectedClass={selectedClass}
//             setSelectedClass={setSelectedClass}
//             selectedYear={selectedYear}
//             setSelectedYear={setSelectedYear}
//             planFile={planFile}
//             setPlanFile={setPlanFile}
//             uploadingPlan={uploadingPlan}
//             uploadYearlyPlan={uploadYearlyPlan}
//             existingPlans={existingPlans}
//             deletePlan={deletePlan}
//             syllabusFile={syllabusFile}
//             setSyllabusFile={setSyllabusFile}
//             uploadingSyllabus={uploadingSyllabus}
//             uploadSyllabus={uploadSyllabus}
//             existingSyllabi={existingSyllabi}
//             deleteSyllabus={deleteSyllabus}
//             examTimetableFile={examTimetableFile}
//             setExamTimetableFile={setExamTimetableFile}
//             uploadingExamTimetable={uploadingExamTimetable}
//             uploadExamTimetable={uploadExamTimetable}
//             existingExamTimetables={existingExamTimetables}
//             deleteExamTimetable={deleteExamTimetable}
//             newExam={newExam}
//             setNewExam={setNewExam}
//           />

//           {/* <SchoolCalendar
//             events={events}
//             newEvent={newEvent}
//             setNewEvent={setNewEvent}
//             addCalendarEvent={addCalendarEvent}
//             updateCalendarEvent={updateCalendarEvent}
//             deleteEvent={deleteEvent}
//             calendarView={calendarView}
//             setCalendarView={setCalendarView}
//             currentDate={currentDate}
//             setCurrentDate={setCurrentDate}
//           />

//           <UpcomingEvents 
//             events={events}
//             setNewEvent={setNewEvent}
//           /> */}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default AcademicAdminDashboard;






























import React, { useState, useEffect } from 'react';
import { ref, push, set, onValue, remove, update } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { database, storage } from '../firebase';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';



// Styles
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: "'Inter', sans-serif"
  },
  header: {
    background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
    color: 'white',
    padding: '1.5rem 2rem',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    marginBottom: '1.5rem'
  },
  cardHeader: {
    backgroundColor: '#f1f5f9',
    borderBottom: '1px solid #e2e8f0',
    padding: '1rem 1.5rem',
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    width: '100%',
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '0.875rem',
    outline: 'none',
    transition: 'all 0.2s',
    boxSizing: 'border-box'
  },
  button: (disabled = false) => ({
    backgroundColor: disabled ? '#cbd5e1' : '#4f46e5',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: disabled ? 'none' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
  }),
  deleteButton: {
    color: '#ef4444',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0.25rem',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  fileInput: {
    display: 'none'
  },
  fileInputLabel: (hasFile) => ({
    display: 'block',
    width: '100%',
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    border: `1px solid ${hasFile ? '#bfdbfe' : '#e2e8f0'}`,
    backgroundColor: hasFile ? '#eff6ff' : 'white',
    cursor: 'pointer',
    fontSize: '0.875rem',
    transition: 'all 0.2s'
  })
};

// Sub-components
const ClassManagement = ({ 
  classes, 
  newClassName, 
  newClassTeacher, 
  newClassRoom, 
  setNewClassName, 
  setNewClassTeacher, 
  setNewClassRoom, 
  addClass, 
  deleteClass 
}) => (
  <div style={styles.card}>
    <div style={styles.cardHeader}>
      <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
      </svg>
      <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Class Management</h2>
    </div>
    <div style={{ padding: '1.5rem' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Class Name</label>
        <input
          type="text"
          style={styles.input}
          value={newClassName}
          onChange={(e) => setNewClassName(e.target.value)}
          placeholder="e.g., Class 1A"
        />
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Teacher</label>
          <input
            type="text"
            style={styles.input}
            value={newClassTeacher}
            onChange={(e) => setNewClassTeacher(e.target.value)}
            placeholder="Teacher's name"
          />
        </div>
        
        <div>
          <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Room</label>
          <input
            type="text"
            style={styles.input}
            value={newClassRoom}
            onChange={(e) => setNewClassRoom(e.target.value)}
            placeholder="Room number"
          />
        </div>
      </div>
      
      <button
        style={styles.button(!newClassName)}
        onClick={addClass}
        disabled={!newClassName}
      >
        Create Class
      </button>
      
      <div style={{ marginTop: '1.5rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
          <svg style={{ width: '1rem', height: '1rem', marginRight: '0.5rem', color: '#64748b' }} fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
          </svg>
          Existing Classes
        </h3>
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          {classes.length > 0 ? (
            classes.map(cls => (
              <div key={cls.id} style={{ 
                padding: '0.75rem', 
                borderRadius: '8px', 
                border: '1px solid #e2e8f0', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                transition: 'all 0.2s',
                ':hover': {
                  borderColor: '#c7d2fe',
                  backgroundColor: '#f8fafc'
                }
              }}>
                <div>
                  <span style={{ fontWeight: '500', color: '#1e293b' }}>{cls.name}</span>
                  <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
                    {cls.teacher && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '0.75rem' }}>
                        <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                        </svg>
                        {cls.teacher}
                      </span>
                    )}
                    {cls.room && (
                      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <svg style={{ width: '0.75rem', height: '0.75rem', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
                        </svg>
                        Room {cls.room}
                      </span>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => deleteClass(cls.id)}
                  style={styles.deleteButton}
                  title="Delete class"
                >
                  <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            ))
          ) : (
            <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
              <svg style={{ width: '3rem', height: '3rem', margin: '0 auto', color: '#cbd5e1' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.5rem' }}>No classes added yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

const AcademicContent = ({ 
  classes, 
  selectedClass, 
  setSelectedClass, 
  selectedYear, 
  setSelectedYear, 
  planFile, 
  setPlanFile, 
  uploadingPlan, 
  uploadYearlyPlan, 
  existingPlans, 
  deletePlan,
  syllabusFile,
  setSyllabusFile,
  uploadingSyllabus,
  uploadSyllabus,
  existingSyllabi,
  deleteSyllabus,
  examTimetableFile,
  setExamTimetableFile,
  uploadingExamTimetable,
  uploadExamTimetable,
  existingExamTimetables,
  deleteExamTimetable,
  newExam,
  setNewExam
}) => (
  <div style={styles.card}>
    <div style={styles.cardHeader}>
      <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
      </svg>
      <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>Academic Content</h2>
    </div>
    <div style={{ padding: '1.5rem' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.5rem' }}>Select Class</label>
        <select
          style={styles.input}
          value={selectedClass}
          onChange={(e) => setSelectedClass(e.target.value)}
        >
          <option value="">Choose a class...</option>
          {classes.map(cls => (
            <option key={cls.id} value={cls.id}>{cls.name}</option>
          ))}
        </select>
      </div>
      
      {selectedClass && (
        <div style={{ display: 'grid', gap: '1.5rem' }}>
          {/* Yearly Plan Section */}
          <div style={{ 
            ...styles.card, 
            backgroundColor: '#f0f9ff',
            border: '1px solid #bfdbfe'
          }}>
            <div style={{ 
              ...styles.cardHeader, 
              backgroundColor: '#e0f2fe',
              borderBottom: '1px solid #bfdbfe'
            }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#0369a1' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z" clipRule="evenodd" />
              </svg>
              <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#0369a1' }}>Yearly Plan</h3>
            </div>
            <div style={{ padding: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Academic Year</label>
                  <input
                    type="number"
                    style={styles.input}
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    min="2000"
                    max="2100"
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Plan File</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={styles.fileInputLabel(planFile)}>
                      {planFile ? planFile.name : 'Choose file...'}
                      <input
                        type="file"
                        style={styles.fileInput}
                        onChange={(e) => setPlanFile(e.target.files[0])}
                        accept=".pdf,.doc,.docx"
                      />
                    </label>
                    {planFile && (
                      <button 
                        onClick={() => setPlanFile(null)}
                        style={{ 
                          marginLeft: '0.5rem', 
                          padding: '0.25rem', 
                          color: '#ef4444', 
                          backgroundColor: 'transparent', 
                          border: 'none', 
                          cursor: 'pointer',
                          borderRadius: '50%'
                        }}
                        title="Remove file"
                      >
                        <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              </div>
              
              <button
                style={styles.button(uploadingPlan || !planFile)}
                onClick={uploadYearlyPlan}
                disabled={uploadingPlan || !planFile}
              >
                {uploadingPlan ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Uploading...
                  </span>
                ) : 'Upload Plan'}
              </button>
              
              {existingPlans.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Existing Plans:</h4>
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    {existingPlans.map(plan => (
                      <div key={plan.id} style={{ 
                        padding: '0.75rem', 
                        borderRadius: '8px', 
                        backgroundColor: 'white', 
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <svg style={{ width: '1.25rem', height: '1.25rem', color: '#3b82f6', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm4-1a1 1 0 10-2 0v4a1 1 0 102 0V8z" clipRule="evenodd" />
                          </svg>
                          <div>
                            <span style={{ fontWeight: '500', color: '#1e293b' }}>{plan.year}</span>
                            <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{plan.fileName}</span>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <a 
                            href={plan.fileUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ 
                              padding: '0.25rem', 
                              color: '#3b82f6', 
                              backgroundColor: '#eff6ff', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            title="View"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </a>
                          <button
                            onClick={() => deletePlan(plan)}
                            style={{ 
                              padding: '0.25rem', 
                              color: '#ef4444', 
                              backgroundColor: '#fef2f2', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: 'none',
                              cursor: 'pointer'
                            }}
                            title="Delete"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Syllabus Section */}
          <div style={{ 
            ...styles.card, 
            backgroundColor: '#ecfdf5',
            border: '1px solid #a7f3d0'
          }}>
            <div style={{ 
              ...styles.cardHeader, 
              backgroundColor: '#d1fae5',
              borderBottom: '1px solid #a7f3d0'
            }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#047857' }} fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
              </svg>
              <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#047857' }}>Class Syllabus</h3>
            </div>
            <div style={{ padding: '1rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Syllabus File</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={styles.fileInputLabel(syllabusFile)}>
                    {syllabusFile ? syllabusFile.name : 'Choose file...'}
                    <input
                      type="file"
                      style={styles.fileInput}
                      onChange={(e) => setSyllabusFile(e.target.files[0])}
                      accept=".pdf,.doc,.docx"
                    />
                  </label>
                  {syllabusFile && (
                    <button 
                      onClick={() => setSyllabusFile(null)}
                      style={{ 
                        marginLeft: '0.5rem', 
                        padding: '0.25rem', 
                        color: '#ef4444', 
                        backgroundColor: 'transparent', 
                        border: 'none', 
                        cursor: 'pointer',
                        borderRadius: '50%'
                      }}
                      title="Remove file"
                    >
                      <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              
              <button
                style={styles.button(uploadingSyllabus || !syllabusFile)}
                onClick={uploadSyllabus}
                disabled={uploadingSyllabus || !syllabusFile}
              >
                {uploadingSyllabus ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Uploading...
                  </span>
                ) : 'Upload Syllabus'}
              </button>
              
              {existingSyllabi.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Current Syllabus:</h4>
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    {existingSyllabi.map(syllabus => (
                      <div key={syllabus.id} style={{ 
                        padding: '0.75rem', 
                        borderRadius: '8px', 
                        backgroundColor: 'white', 
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <svg style={{ width: '1.25rem', height: '1.25rem', color: '#10b981', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                          </svg>
                          <span style={{ fontSize: '0.875rem' }}>{syllabus.fileName}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <a 
                            href={syllabus.fileUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ 
                              padding: '0.25rem', 
                              color: '#10b981', 
                              backgroundColor: '#ecfdf5', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            title="View"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </a>
                          <button
                            onClick={() => deleteSyllabus(syllabus)}
                            style={{ 
                              padding: '0.25rem', 
                              color: '#ef4444', 
                              backgroundColor: '#fef2f2', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: 'none',
                              cursor: 'pointer'
                            }}
                            title="Delete"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Exam Timetable Section */}
          <div style={{ 
            ...styles.card, 
            backgroundColor: '#f5f3ff',
            border: '1px solid #c4b5fd'
          }}>
            <div style={{ 
              ...styles.cardHeader, 
              backgroundColor: '#ede9fe',
              borderBottom: '1px solid #c4b5fd'
            }}>
              <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#7c3aed' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
              </svg>
              <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#7c3aed' }}>Exam Timetable</h3>
            </div>
            <div style={{ padding: '1rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Exam Name</label>
                <input
                  type="text"
                  style={styles.input}
                  value={newExam.name}
                  onChange={(e) => setNewExam({...newExam, name: e.target.value})}
                  placeholder="e.g., Mid-Term Exams"
                />
              </div>
              
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Timetable File</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={styles.fileInputLabel(examTimetableFile)}>
                    {examTimetableFile ? examTimetableFile.name : 'Choose file...'}
                    <input
                      type="file"
                      style={styles.fileInput}
                      onChange={(e) => setExamTimetableFile(e.target.files[0])}
                      accept=".pdf,.doc,.docx,.jpg,.png"
                    />
                  </label>
                  {examTimetableFile && (
                    <button 
                      onClick={() => setExamTimetableFile(null)}
                      style={{ 
                        marginLeft: '0.5rem', 
                        padding: '0.25rem', 
                        color: '#ef4444', 
                        backgroundColor: 'transparent', 
                        border: 'none', 
                        cursor: 'pointer',
                        borderRadius: '50%'
                      }}
                      title="Remove file"
                    >
                      <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              
              <button
                style={styles.button(uploadingExamTimetable || !examTimetableFile)}
                onClick={uploadExamTimetable}
                disabled={uploadingExamTimetable || !examTimetableFile}
              >
                {uploadingExamTimetable ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Uploading...
                  </span>
                ) : 'Upload Timetable'}
              </button>
              
              {existingExamTimetables.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.5rem' }}>Uploaded Timetables:</h4>
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    {existingExamTimetables.map(timetable => (
                      <div key={timetable.id} style={{ 
                        padding: '0.75rem', 
                        borderRadius: '8px', 
                        backgroundColor: 'white', 
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <svg style={{ width: '1.25rem', height: '1.25rem', color: '#7c3aed', marginRight: '0.75rem' }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                          </svg>
                          <div>
                            <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>{timetable.examName || 'Exam Timetable'}</span>
                            <span style={{ display: 'block', fontSize: '0.75rem', color: '#64748b' }}>{timetable.fileName}</span>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <a 
                            href={timetable.fileUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ 
                              padding: '0.25rem', 
                              color: '#7c3aed', 
                              backgroundColor: '#ede9fe', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            title="View"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </a>
                          <button
                            onClick={() => deleteExamTimetable(timetable)}
                            style={{ 
                              padding: '0.25rem', 
                              color: '#ef4444', 
                              backgroundColor: '#fef2f2', 
                              borderRadius: '50%',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: 'none',
                              cursor: 'pointer'
                            }}
                            title="Delete"
                          >
                            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);

const AcademicAdminDashboard = () => {
  // State for Classes Management
  const [classes, setClasses] = useState([]);
  const [newClassName, setNewClassName] = useState('');
  const [newClassTeacher, setNewClassTeacher] = useState('');
  const [newClassRoom, setNewClassRoom] = useState('');

  // State for Yearly Plans
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [planFile, setPlanFile] = useState(null);
  const [uploadingPlan, setUploadingPlan] = useState(false);
  const [existingPlans, setExistingPlans] = useState([]);

  // State for Syllabus Management
  const [syllabusFile, setSyllabusFile] = useState(null);
  const [uploadingSyllabus, setUploadingSyllabus] = useState(false);
  const [existingSyllabi, setExistingSyllabi] = useState([]);

  // State for Exam Timetables
  const [examTimetableFile, setExamTimetableFile] = useState(null);
  const [uploadingExamTimetable, setUploadingExamTimetable] = useState(false);
  const [existingExamTimetables, setExistingExamTimetables] = useState([]);


  // Add these state variables near the other state declarations
const [kgCalendarFile, setKgCalendarFile] = useState(null);
const [primaryCalendarFile, setPrimaryCalendarFile] = useState(null);
const [uploadingKgCalendar, setUploadingKgCalendar] = useState(false);
const [uploadingPrimaryCalendar, setUploadingPrimaryCalendar] = useState(false);
const [existingCalendars, setExistingCalendars] = useState([]);

  // State for Exams Management
  const [exams, setExams] = useState([]);
  const [newExam, setNewExam] = useState({
    name: '',
    date: new Date().toISOString().split('T')[0],
    description: '',
    syllabusCovered: ''
  });

  // State for School Calendar
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({
    title: '',
    start: new Date(),
    end: new Date(),
    description: '',
    type: 'holiday'
  });



  // Fetch all classes
  useEffect(() => {
    const classesRef = ref(database, 'school/classes');
    onValue(classesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const classesArray = Object.entries(data).map(([id, classData]) => ({
          id,
          ...classData
        }));
        setClasses(classesArray);
      }
    });
  }, []);

  // Fetch existing yearly plans when class is selected
  useEffect(() => {
    if (selectedClass) {
      const plansRef = ref(database, `school/academic/${selectedClass}/yearlyPlans`);
      onValue(plansRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const plansArray = Object.entries(data).map(([id, plan]) => ({
            id,
            ...plan
          }));
          setExistingPlans(plansArray);
        } else {
          setExistingPlans([]);
        }
      });
    }
  }, [selectedClass]);

  // Fetch existing syllabi when class is selected
  useEffect(() => {
    if (selectedClass) {
      const syllabiRef = ref(database, `school/academic/${selectedClass}/syllabus`);
      onValue(syllabiRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const syllabiArray = Object.entries(data).map(([id, syllabus]) => ({
            id,
            ...syllabus
          }));
          setExistingSyllabi(syllabiArray);
        } else {
          setExistingSyllabi([]);
        }
      });
    }
  }, [selectedClass]);

  // Fetch exam timetables when class is selected
  useEffect(() => {
    if (selectedClass) {
      const timetablesRef = ref(database, `school/academic/${selectedClass}/examTimetables`);
      onValue(timetablesRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const timetablesArray = Object.entries(data).map(([id, timetable]) => ({
            id,
            ...timetable
          }));
          setExistingExamTimetables(timetablesArray);
        } else {
          setExistingExamTimetables([]);
        }
      });
    }
  }, [selectedClass]);

  // Fetch calendar events
  useEffect(() => {
    const eventsRef = ref(database, 'school/academic/calendar');
    onValue(eventsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const eventsArray = Object.entries(data).map(([id, event]) => ({
          id,
          ...event,
          start: new Date(event.start),
          end: new Date(event.end)
        }));
        setEvents(eventsArray);
      } else {
        setEvents([]);
      }
    });
  }, []);

  // Add new class
  const addClass = async () => {
    if (!newClassName) {
      alert('Please enter class name');
      return;
    }

    try {
      const classRef = push(ref(database, 'school/classes'));
      await set(classRef, {
        name: newClassName,
        teacher: newClassTeacher,
        room: newClassRoom,
        createdAt: new Date().toISOString()
      });

      setNewClassName('');
      setNewClassTeacher('');
      setNewClassRoom('');
    } catch (error) {
      console.error('Error adding class:', error);
      alert('Failed to add class');
    }
  };

  // Delete class
  const deleteClass = async (classId) => {
    if (window.confirm('Are you sure you want to delete this class and all its academic data?')) {
      try {
        // Delete class record
        await remove(ref(database, `school/classes/${classId}`));
        
        // Delete academic data
        await remove(ref(database, `school/academic/${classId}`));
        
        alert('Class deleted successfully');
      } catch (error) {
        console.error('Error deleting class:', error);
        alert('Failed to delete class');
      }
    }
  };

  // Upload Yearly Plan
  const uploadYearlyPlan = async () => {
    if (!selectedClass || !planFile) {
      alert('Please select a class and file');
      return;
    }

    try {
      setUploadingPlan(true);
      
      // Upload file to storage
      const filePath = `academic/${selectedClass}/plans/${selectedYear}-${Date.now()}`;
      const fileRef = storageRef(storage, filePath);
      await uploadBytes(fileRef, planFile);
      const downloadURL = await getDownloadURL(fileRef);

      // Save to database
      const planRef = push(ref(database, `school/academic/${selectedClass}/yearlyPlans`));
      await set(planRef, {
        year: selectedYear,
        fileUrl: downloadURL,
        fileName: planFile.name,
        storagePath: filePath,
        uploadedAt: new Date().toISOString()
      });

      alert('Yearly plan uploaded successfully!');
      setPlanFile(null);
    } catch (error) {
      console.error('Error uploading plan:', error);
      alert('Failed to upload plan');
    } finally {
      setUploadingPlan(false);
    }
  };

  // Delete Yearly Plan
  const deletePlan = async (plan) => {
    if (window.confirm('Are you sure you want to delete this plan?')) {
      try {
        // Delete from storage
        if (plan.storagePath) {
          const fileRef = storageRef(storage, plan.storagePath);
          await deleteObject(fileRef);
        }

        // Delete from database
        await remove(ref(database, `school/academic/${selectedClass}/yearlyPlans/${plan.id}`));
        
        alert('Plan deleted successfully');
      } catch (error) {
        console.error('Error deleting plan:', error);
        alert('Failed to delete plan');
      }
    }
  };

  // Upload Syllabus
  const uploadSyllabus = async () => {
    if (!selectedClass || !syllabusFile) {
      alert('Please select a class and file');
      return;
    }

    try {
      setUploadingSyllabus(true);
      
      // Upload file to storage
      const filePath = `academic/${selectedClass}/syllabus/${Date.now()}`;
      const fileRef = storageRef(storage, filePath);
      await uploadBytes(fileRef, syllabusFile);
      const downloadURL = await getDownloadURL(fileRef);

      // Save to database
      const syllabusRef = push(ref(database, `school/academic/${selectedClass}/syllabus`));
      await set(syllabusRef, {
        fileUrl: downloadURL,
        fileName: syllabusFile.name,
        storagePath: filePath,
        uploadedAt: new Date().toISOString()
      });

      alert('Syllabus uploaded successfully!');
      setSyllabusFile(null);
    } catch (error) {
      console.error('Error uploading syllabus:', error);
      alert('Failed to upload syllabus');
    } finally {
      setUploadingSyllabus(false);
    }
  };

  // Delete Syllabus
  const deleteSyllabus = async (syllabus) => {
    if (window.confirm('Are you sure you want to delete this syllabus?')) {
      try {
        // Delete from storage
        if (syllabus.storagePath) {
          const fileRef = storageRef(storage, syllabus.storagePath);
          await deleteObject(fileRef);
        }

        // Delete from database
        await remove(ref(database, `school/academic/${selectedClass}/syllabus/${syllabus.id}`));
        
        alert('Syllabus deleted successfully');
      } catch (error) {
        console.error('Error deleting syllabus:', error);
        alert('Failed to delete syllabus');
      }
    }
  };

  // Upload Exam Timetable
  const uploadExamTimetable = async () => {
    if (!selectedClass || !examTimetableFile) {
      alert('Please select a class and file');
      return;
    }

    try {
      setUploadingExamTimetable(true);
      
      // Upload file to storage
      const filePath = `academic/${selectedClass}/examTimetables/${Date.now()}`;
      const fileRef = storageRef(storage, filePath);
      await uploadBytes(fileRef, examTimetableFile);
      const downloadURL = await getDownloadURL(fileRef);

      // Save to database
      const timetableRef = push(ref(database, `school/academic/${selectedClass}/examTimetables`));
      await set(timetableRef, {
        fileUrl: downloadURL,
        fileName: examTimetableFile.name,
        storagePath: filePath,
        uploadedAt: new Date().toISOString(),
        examName: newExam.name || 'General Timetable'
      });

      alert('Exam timetable uploaded successfully!');
      setExamTimetableFile(null);
    } catch (error) {
      console.error('Error uploading timetable:', error);
      alert('Failed to upload timetable');
    } finally {
      setUploadingExamTimetable(false);
    }
  };

  // Delete Exam Timetable
  const deleteExamTimetable = async (timetable) => {
    if (window.confirm('Are you sure you want to delete this exam timetable?')) {
      try {
        // Delete from storage
        if (timetable.storagePath) {
          const fileRef = storageRef(storage, timetable.storagePath);
          await deleteObject(fileRef);
        }

        // Delete from database
        await remove(ref(database, `school/academic/${selectedClass}/examTimetables/${timetable.id}`));
        
        alert('Exam timetable deleted successfully');
      } catch (error) {
        console.error('Error deleting timetable:', error);
        alert('Failed to delete timetable');
      }
    }
  };



  // Add these functions near the other upload functions
const uploadKgCalendar = async () => {
  if (!kgCalendarFile) {
    alert('Please select a file');
    return;
  }

  try {
    setUploadingKgCalendar(true);
    
    // Upload file to storage
    const filePath = `academic/calendars/kg/${Date.now()}`;
    const fileRef = storageRef(storage, filePath);
    await uploadBytes(fileRef, kgCalendarFile);
    const downloadURL = await getDownloadURL(fileRef);

    // Save to database
    const calendarRef = push(ref(database, 'school/academic/calendars'));
    await set(calendarRef, {
      fileUrl: downloadURL,
      fileName: kgCalendarFile.name,
      storagePath: filePath,
      type: 'kg',
      uploadedAt: new Date().toISOString()
    });

    alert('KG Calendar uploaded successfully!');
    setKgCalendarFile(null);
  } catch (error) {
    console.error('Error uploading KG calendar:', error);
    alert('Failed to upload KG calendar');
  } finally {
    setUploadingKgCalendar(false);
  }
};

const uploadPrimaryCalendar = async () => {
  if (!primaryCalendarFile) {
    alert('Please select a file');
    return;
  }

  try {
    setUploadingPrimaryCalendar(true);
    
    // Upload file to storage
    const filePath = `academic/calendars/primary/${Date.now()}`;
    const fileRef = storageRef(storage, filePath);
    await uploadBytes(fileRef, primaryCalendarFile);
    const downloadURL = await getDownloadURL(fileRef);

    // Save to database
    const calendarRef = push(ref(database, 'school/academic/calendars'));
    await set(calendarRef, {
      fileUrl: downloadURL,
      fileName: primaryCalendarFile.name,
      storagePath: filePath,
      type: 'primary',
      uploadedAt: new Date().toISOString()
    });

    alert('Primary Calendar uploaded successfully!');
    setPrimaryCalendarFile(null);
  } catch (error) {
    console.error('Error uploading Primary calendar:', error);
    alert('Failed to upload Primary calendar');
  } finally {
    setUploadingPrimaryCalendar(false);
  }
};

const deleteCalendar = async (calendar) => {
  if (window.confirm('Are you sure you want to delete this calendar?')) {
    try {
      // Delete from storage
      if (calendar.storagePath) {
        const fileRef = storageRef(storage, calendar.storagePath);
        await deleteObject(fileRef);
      }

      // Delete from database
      await remove(ref(database, `school/academic/calendars/${calendar.id}`));
      
      alert('Calendar deleted successfully');
    } catch (error) {
      console.error('Error deleting calendar:', error);
      alert('Failed to delete calendar');
    }
  }
};


// Add this useEffect near the other useEffects
useEffect(() => {
  const calendarsRef = ref(database, 'school/academic/calendars');
  onValue(calendarsRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const calendarsArray = Object.entries(data).map(([id, calendar]) => ({
        id,
        ...calendar
      }));
      setExistingCalendars(calendarsArray);
    } else {
      setExistingCalendars([]);
    }
  });
}, []);


const CalendarManagement = ({ 
  kgCalendarFile,
  setKgCalendarFile,
  uploadingKgCalendar,
  uploadKgCalendar,
  primaryCalendarFile,
  setPrimaryCalendarFile,
  uploadingPrimaryCalendar,
  uploadPrimaryCalendar,
  existingCalendars,
  deleteCalendar
}) => (
  <div style={styles.card}>
    <div style={styles.cardHeader}>
      <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#4f46e5' }} fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
      </svg>
      <h2 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#1e293b' }}>School Calendar Management</h2>
    </div>
    <div style={{ padding: '1.5rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '1.5rem' }}>
        {/* KG Calendar */}
        <div style={{ 
          ...styles.card, 
          backgroundColor: '#f0fdf4',
          border: '1px solid #86efac'
        }}>
          <div style={{ 
            ...styles.cardHeader, 
            backgroundColor: '#dcfce7',
            borderBottom: '1px solid #86efac'
          }}>
            <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#16a34a' }} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
            </svg>
            <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#16a34a' }}>KG Section Calendar</h3>
          </div>
          <div style={{ padding: '1rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Calendar File</label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={styles.fileInputLabel(kgCalendarFile)}>
                  {kgCalendarFile ? kgCalendarFile.name : 'Choose file...'}
                  <input
                    type="file"
                    style={styles.fileInput}
                    onChange={(e) => setKgCalendarFile(e.target.files[0])}
                    accept=".pdf,.doc,.docx,.jpg,.png"
                  />
                </label>
                {kgCalendarFile && (
                  <button 
                    onClick={() => setKgCalendarFile(null)}
                    style={{ 
                      marginLeft: '0.5rem', 
                      padding: '0.25rem', 
                      color: '#ef4444', 
                      backgroundColor: 'transparent', 
                      border: 'none', 
                      cursor: 'pointer',
                      borderRadius: '50%'
                    }}
                    title="Remove file"
                  >
                    <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            
            <button
              style={styles.button(uploadingKgCalendar || !kgCalendarFile)}
              onClick={uploadKgCalendar}
              disabled={uploadingKgCalendar || !kgCalendarFile}
            >
              {uploadingKgCalendar ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Uploading...
                </span>
              ) : 'Upload KG Calendar'}
            </button>
          </div>
        </div>
        
        {/* Primary Calendar */}
        <div style={{ 
          ...styles.card, 
          backgroundColor: '#eff6ff',
          border: '1px solid #93c5fd'
        }}>
          <div style={{ 
            ...styles.cardHeader, 
            backgroundColor: '#dbeafe',
            borderBottom: '1px solid #93c5fd'
          }}>
            <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.5rem', color: '#2563eb' }} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
            </svg>
            <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0, color: '#2563eb' }}>Primary Section Calendar</h3>
          </div>
          <div style={{ padding: '1rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#334155', marginBottom: '0.25rem' }}>Calendar File</label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={styles.fileInputLabel(primaryCalendarFile)}>
                  {primaryCalendarFile ? primaryCalendarFile.name : 'Choose file...'}
                  <input
                    type="file"
                    style={styles.fileInput}
                    onChange={(e) => setPrimaryCalendarFile(e.target.files[0])}
                    accept=".pdf,.doc,.docx,.jpg,.png"
                  />
                </label>
                {primaryCalendarFile && (
                  <button 
                    onClick={() => setPrimaryCalendarFile(null)}
                    style={{ 
                      marginLeft: '0.5rem', 
                      padding: '0.25rem', 
                      color: '#ef4444', 
                      backgroundColor: 'transparent', 
                      border: 'none', 
                      cursor: 'pointer',
                      borderRadius: '50%'
                    }}
                    title="Remove file"
                  >
                    <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            
            <button
              style={styles.button(uploadingPrimaryCalendar || !primaryCalendarFile)}
              onClick={uploadPrimaryCalendar}
              disabled={uploadingPrimaryCalendar || !primaryCalendarFile}
            >
              {uploadingPrimaryCalendar ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg style={{ animation: 'spin 1s linear infinite', marginRight: '0.5rem', width: '1rem', height: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Uploading...
                </span>
              ) : 'Upload Primary Calendar'}
            </button>
          </div>
        </div>
      </div>
      
      {existingCalendars.length > 0 && (
        <div>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.75rem', display: 'flex', alignItems: 'center' }}>
            <svg style={{ width: '1rem', height: '1rem', marginRight: '0.5rem', color: '#64748b' }} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
            </svg>
            Uploaded Calendars
          </h3>
          <div style={{ display: 'grid', gap: '0.75rem' }}>
            {existingCalendars.map(calendar => (
              <div key={calendar.id} style={{ 
                padding: '0.75rem', 
                borderRadius: '8px', 
                border: '1px solid #e2e8f0', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                backgroundColor: calendar.type === 'kg' ? '#f0fdf4' : '#eff6ff'
              }}>
                <div>
                  <span style={{ fontWeight: '500', color: '#1e293b' }}>
                    {calendar.type === 'kg' ? 'KG Section' : 'Primary Section'} Calendar
                  </span>
                  <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
                    {calendar.fileName}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <a 
                    href={calendar.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ 
                      padding: '0.25rem', 
                      color: calendar.type === 'kg' ? '#16a34a' : '#2563eb', 
                      backgroundColor: calendar.type === 'kg' ? '#dcfce7' : '#dbeafe', 
                      borderRadius: '50%',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    title="View"
                  >
                    <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </a>
                  <button
                    onClick={() => deleteCalendar(calendar)}
                    style={{ 
                      padding: '0.25rem', 
                      color: '#ef4444', 
                      backgroundColor: '#fef2f2', 
                      borderRadius: '50%',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                    title="Delete"
                  >
                    <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
);


  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>Academic Administration</h1>
        <p style={{ margin: '0.25rem 0 0', opacity: 0.9, fontSize: '0.875rem' }}>
          Manage classes, curriculum, and school calendar
        </p>
      </header>

      <main style={{ maxWidth: '1200px', margin: '2rem auto 0', padding: '0 1.5rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
          <ClassManagement 
            classes={classes}
            newClassName={newClassName}
            newClassTeacher={newClassTeacher}
            newClassRoom={newClassRoom}
            setNewClassName={setNewClassName}
            setNewClassTeacher={setNewClassTeacher}
            setNewClassRoom={setNewClassRoom}
            addClass={addClass}
            deleteClass={deleteClass}
          />

          <AcademicContent
            classes={classes}
            selectedClass={selectedClass}
            setSelectedClass={setSelectedClass}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            planFile={planFile}
            setPlanFile={setPlanFile}
            uploadingPlan={uploadingPlan}
            uploadYearlyPlan={uploadYearlyPlan}
            existingPlans={existingPlans}
            deletePlan={deletePlan}
            syllabusFile={syllabusFile}
            setSyllabusFile={setSyllabusFile}
            uploadingSyllabus={uploadingSyllabus}
            uploadSyllabus={uploadSyllabus}
            existingSyllabi={existingSyllabi}
            deleteSyllabus={deleteSyllabus}
            examTimetableFile={examTimetableFile}
            setExamTimetableFile={setExamTimetableFile}
            uploadingExamTimetable={uploadingExamTimetable}
            uploadExamTimetable={uploadExamTimetable}
            existingExamTimetables={existingExamTimetables}
            deleteExamTimetable={deleteExamTimetable}
            newExam={newExam}
            setNewExam={setNewExam}
          />


        
<CalendarManagement
  kgCalendarFile={kgCalendarFile}
  setKgCalendarFile={setKgCalendarFile}
  uploadingKgCalendar={uploadingKgCalendar}
  uploadKgCalendar={uploadKgCalendar}
  primaryCalendarFile={primaryCalendarFile}
  setPrimaryCalendarFile={setPrimaryCalendarFile}
  uploadingPrimaryCalendar={uploadingPrimaryCalendar}
  uploadPrimaryCalendar={uploadPrimaryCalendar}
  existingCalendars={existingCalendars}
  deleteCalendar={deleteCalendar}
/>
        </div>
      </main>
    </div>
  );
};

export default AcademicAdminDashboard;










